import e, { Children as t, createContext as n, useCallback as r, useContext as i, useEffect as a, useLayoutEffect as o, useMemo as s, useReducer as c, useRef as l, useState as u } from "react";
import { Fragment as d, jsx as f, jsxs as p } from "react/jsx-runtime";
import { Editor as m, Element as h, Node as g, Operation as _, Path as v, Point as y, Range as b, Text as x, Transforms as S, createEditor as ee } from "slate";
import { Editable as te, ReactEditor as C, Slate as ne, useFocused as w, useSelected as re, useSlate as T, useSlateSelection as E, useSlateSelector as ie, useSlateStatic as D, withReact as O } from "slate-react";
import * as k from "yjs";
import { CursorEditor as A, YjsEditor as j, relativePositionToSlatePoint as M, slatePointToRelativePosition as N, withCursors as P, withYHistory as F, withYjs as ae } from "@slate-yjs/core";
import { useRemoteCursorOverlayPositions as oe } from "@slate-yjs/react";
import { createPortal as I } from "react-dom";
//#region ../../node_modules/.pnpm/is-plain-object@5.0.0/node_modules/is-plain-object/dist/is-plain-object.mjs
function L(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function se(e) {
	var t, n;
	return L(e) !== !1 && (t = e.constructor, t === void 0 || (n = t.prototype, L(n) !== !1 && n.hasOwnProperty("isPrototypeOf") !== !1));
}
//#endregion
//#region ../../node_modules/.pnpm/slate-history@0.113.1_slate@0.126.2/node_modules/slate-history/dist/index.es.js
var ce = { isHistory(e) {
	return se(e) && Array.isArray(e.redos) && Array.isArray(e.undos) && (e.redos.length === 0 || _.isOperationList(e.redos[0].operations)) && (e.undos.length === 0 || _.isOperationList(e.undos[0].operations));
} }, R = /* @__PURE__ */ new WeakMap(), z = /* @__PURE__ */ new WeakMap(), B = /* @__PURE__ */ new WeakMap(), V = {
	isHistoryEditor(e) {
		return ce.isHistory(e.history) && m.isEditor(e);
	},
	isMerging(e) {
		return z.get(e);
	},
	isSplittingOnce(e) {
		return B.get(e);
	},
	setSplittingOnce(e, t) {
		B.set(e, t);
	},
	isSaving(e) {
		return R.get(e);
	},
	redo(e) {
		e.redo();
	},
	undo(e) {
		e.undo();
	},
	withMerging(e, t) {
		var n = V.isMerging(e);
		z.set(e, !0), t(), z.set(e, n);
	},
	withNewBatch(e, t) {
		var n = V.isMerging(e);
		z.set(e, !0), B.set(e, !0), t(), z.set(e, n), B.delete(e);
	},
	withoutMerging(e, t) {
		var n = V.isMerging(e);
		z.set(e, !1), t(), z.set(e, n);
	},
	withoutSaving(e, t) {
		var n = V.isSaving(e);
		R.set(e, !1);
		try {
			t();
		} finally {
			R.set(e, n);
		}
	}
}, le = (e) => {
	var t = e, { apply: n } = t;
	return t.history = {
		undos: [],
		redos: []
	}, t.redo = () => {
		var { history: e } = t, { redos: n } = e;
		if (n.length > 0) {
			var r = n[n.length - 1];
			r.selectionBefore && S.setSelection(t, r.selectionBefore), V.withoutSaving(t, () => {
				m.withoutNormalizing(t, () => {
					for (var e of r.operations) t.apply(e);
				});
			}), e.redos.pop(), t.writeHistory("undos", r);
		}
	}, t.undo = () => {
		var { history: e } = t, { undos: n } = e;
		if (n.length > 0) {
			var r = n[n.length - 1];
			V.withoutSaving(t, () => {
				m.withoutNormalizing(t, () => {
					for (var e of r.operations.map(_.inverse).reverse()) t.apply(e);
					r.selectionBefore && S.setSelection(t, r.selectionBefore);
				});
			}), t.writeHistory("redos", r), e.undos.pop();
		}
	}, t.apply = (e) => {
		var { operations: r, history: i } = t, { undos: a } = i, o = a[a.length - 1], s = o && o.operations[o.operations.length - 1], c = V.isSaving(t), l = V.isMerging(t);
		if (c ??= de(e), c) {
			if (l ??= o == null ? !1 : r.length !== 0 || ue(e, s), V.isSplittingOnce(t) && (l = !1, V.setSplittingOnce(t, void 0)), o && l) o.operations.push(e);
			else {
				var u = {
					operations: [e],
					selectionBefore: t.selection
				};
				t.writeHistory("undos", u);
			}
			for (; a.length > 100;) a.shift();
			i.redos = [];
		}
		n(e);
	}, t.writeHistory = (e, n) => {
		t.history[e].push(n);
	}, t;
}, ue = (e, t) => !!(t && e.type === "insert_text" && t.type === "insert_text" && e.offset === t.offset + t.text.length && v.equals(e.path, t.path) || t && e.type === "remove_text" && t.type === "remove_text" && e.offset + e.text.length === t.offset && v.equals(e.path, t.path)), de = (e, t) => e.type !== "set_selection", fe = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports);
if (typeof document < "u") {
	let e = "textbit-keyframes";
	if (!document.getElementById(e)) {
		let t = document.createElement("style");
		t.id = e, t.textContent = [
			"@keyframes block-caret-blink{0%,100%{opacity:1}50%{opacity:0}}",
			"[data-state=\"active\"] .tb-focus-ring{outline:1px solid currentColor;outline-offset:4px;border-radius:var(--tb-focus-ring-radius,5px);opacity:0.3}",
			".tb-newline{background:var(--tb-newline-background,color-mix(in srgb,currentColor 18%,transparent));box-shadow:inset 0 0 0 1px var(--tb-newline-border,color-mix(in srgb,currentColor 45%,transparent));border-radius:var(--tb-newline-radius,2px)}",
			".tb-newline::before{content:var(--tb-newline-symbol,'\\21B5');opacity:0.6;user-select:none;-webkit-user-select:none;pointer-events:none}"
		].join(""), document.head.appendChild(t);
	}
}
var pe = n({
	verbose: !1,
	readOnly: !1,
	collaborative: !1,
	dir: "ltr",
	lang: "en",
	debounce: 250,
	spellcheckDebounce: 1250,
	placeholder: "",
	placeholders: "none",
	stats: {
		full: {
			words: 0,
			characters: 0
		},
		short: {
			words: 0,
			characters: 0
		}
	},
	dispatch: () => {}
}), me = (e, t) => {
	let { stats: n } = t, r = {};
	return n && (r.stats = n), {
		...e,
		...r
	};
};
function he({ children: e, verbose: t, readOnly: n, collaborative: r, dir: i, lang: a, debounce: o, spellcheckDebounce: s, placeholder: l, placeholders: u }) {
	let [d, p] = c(me, {
		verbose: t ?? !1,
		readOnly: n ?? !1,
		collaborative: r ?? !1,
		dir: i ?? "ltr",
		lang: a ?? "en",
		debounce: o ?? 250,
		spellcheckDebounce: s ?? 1250,
		placeholder: l ?? "",
		placeholders: u ?? "none",
		stats: {
			full: {
				words: 0,
				characters: 0
			},
			short: {
				words: 0,
				characters: 0
			}
		},
		dispatch: () => {}
	});
	return /* @__PURE__ */ f(pe.Provider, {
		value: {
			...d,
			dispatch: p
		},
		children: e
	});
}
function ge(e, t, n) {
	n?.verbose && console.info(`Registering plugin ${t.name}`);
	let r = [...e], i = r.findIndex((e) => e.name === t.name);
	return i === -1 ? r.push(t) : (console.warn(`%c Overriding already registered plugin ${t.name}`), r[i] = t), r;
}
var _e = (e, t, n, r, i) => {
	let a = /* @__PURE__ */ new Map();
	return e.forEach((e, t) => {
		a.set(t, e);
	}), ve(a, t, n, r || {}, i || {}), a;
}, ve = (e, t, n, r, i) => {
	e.has(t) && r.verbose && console.info(`%c Component ${t} render function overrided by new render component with the same type`), n.class || console.warn(`Component ${t} is missing a class, using "text" as fallback type`), e.set(t, {
		type: t,
		class: n.class || "text",
		componentEntry: n,
		parent: r?.parent || null,
		pluginOptions: i || /* @__PURE__ */ new Map()
	});
	let { children: a = [] } = n;
	a.forEach((a) => {
		if (!a.type) throw Error(`Child component of ${t} is missing mandatory type`);
		ve(e, `${t}/${a.type}`, a, {
			verbose: r.verbose,
			parent: n
		}, i);
	});
}, ye = (/* @__PURE__ */ fe(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	for (var t = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), n = {
		alt: "altKey",
		control: "ctrlKey",
		meta: "metaKey",
		shift: "shiftKey"
	}, r = {
		add: "+",
		break: "pause",
		cmd: "meta",
		command: "meta",
		ctl: "control",
		ctrl: "control",
		del: "delete",
		down: "arrowdown",
		esc: "escape",
		ins: "insert",
		left: "arrowleft",
		mod: t ? "meta" : "control",
		opt: "alt",
		option: "alt",
		return: "enter",
		right: "arrowright",
		space: " ",
		spacebar: " ",
		up: "arrowup",
		win: "meta",
		windows: "meta"
	}, i = {
		backspace: 8,
		tab: 9,
		enter: 13,
		shift: 16,
		control: 17,
		alt: 18,
		pause: 19,
		capslock: 20,
		escape: 27,
		" ": 32,
		pageup: 33,
		pagedown: 34,
		end: 35,
		home: 36,
		arrowleft: 37,
		arrowup: 38,
		arrowright: 39,
		arrowdown: 40,
		insert: 45,
		delete: 46,
		meta: 91,
		numlock: 144,
		scrolllock: 145,
		";": 186,
		"=": 187,
		",": 188,
		"-": 189,
		".": 190,
		"/": 191,
		"`": 192,
		"[": 219,
		"\\": 220,
		"]": 221,
		"'": 222
	}, a = 1; a < 20; a++) i["f" + a] = 111 + a;
	function o(e, t, n) {
		t && !("byKey" in t) && (n = t, t = null), Array.isArray(e) || (e = [e]);
		var r = e.map(function(e) {
			return s(e, t);
		}), i = function(e) {
			return r.some(function(t) {
				return c(t, e);
			});
		};
		return n == null ? i : i(n);
	}
	function s(e, t) {
		var a = t && t.byKey, o = {};
		e = e.replace("++", "+add");
		var s = e.split("+"), c = s.length;
		for (var d in n) o[n[d]] = !1;
		var f = !0, p = !1, m = void 0;
		try {
			for (var h = s[Symbol.iterator](), g; !(f = (g = h.next()).done); f = !0) {
				var _ = g.value, v = _.endsWith("?") && _.length > 1;
				v && (_ = _.slice(0, -1));
				var y = u(_), b = n[y];
				if (_.length > 1 && !b && !r[_] && !i[y]) throw TypeError("Unknown modifier: \"" + _ + "\"");
				(c === 1 || !b) && (a ? o.key = y : o.which = l(_)), b && (o[b] = !v || null);
			}
		} catch (e) {
			p = !0, m = e;
		} finally {
			try {
				!f && h.return && h.return();
			} finally {
				if (p) throw m;
			}
		}
		return o;
	}
	function c(e, t) {
		for (var n in e) {
			var r = e[n], i = void 0;
			if (r != null && (i = n === "key" && t.key != null ? t.key.toLowerCase() : n === "which" ? r === 91 && t.which === 93 ? 91 : t.which : t[n], (i != null || r !== !1) && i !== r)) return !1;
		}
		return !0;
	}
	function l(e) {
		return e = u(e), i[e] || e.toUpperCase().charCodeAt(0);
	}
	function u(e) {
		return e = e.toLowerCase(), e = r[e] || e, e;
	}
	e.isHotkey = o;
})))(), be = (e) => {
	let t = [];
	return e.filter((e) => Array.isArray(e.actions) && e.actions.length).forEach((e) => {
		e.actions?.forEach((n) => {
			let r = typeof n.hotkey == "string" ? (0, ye.isHotkey)(n.hotkey) : () => !1;
			t.push({
				plugin: e,
				isHotkey: r,
				...n,
				name: `${e.name}/${n.name}`
			});
		});
	}), t;
}, H = {
	isLeafPlugin: (e) => e?.class === "leaf",
	isElementPlugin: (e) => e?.class !== "leaf"
}, xe = () => ({
	plugins: [],
	components: /* @__PURE__ */ new Map(),
	actions: [],
	verbose: !1,
	dispatch: () => {}
}), Se = n(xe()), Ce = (e, t) => {
	let { action: n, plugin: r } = t;
	return n === "delete" ? (console.warn("Deleting plugins from plugin registry not implemented"), e) : {
		...e,
		...Te(e, r, { verbose: e.verbose })
	};
};
function we({ children: e, verbose: t, plugins: n }) {
	let r = Ee(xe(), n, { verbose: t }), [i, a] = c(Ce, {
		...xe(),
		...r
	});
	return /* @__PURE__ */ f(Se.Provider, {
		value: {
			...i,
			dispatch: a
		},
		children: e
	});
}
function Te(e, t, n) {
	let r = ge(e.plugins, t, n);
	return {
		plugins: r,
		actions: be(r),
		components: H.isElementPlugin(t) && t?.componentEntry ? _e(e.components, t.componentEntry?.type || t.name, t.componentEntry, n, t.options) : e.components
	};
}
function Ee(e, t, n) {
	return t.forEach((t) => {
		e.plugins = ge(e.plugins, t, n), e.actions = be(e.plugins), H.isElementPlugin(t) && t?.componentEntry && (e.components = _e(e.components, t.componentEntry?.type || t.name, t.componentEntry, n, t.options));
	}), { ...e };
}
var U = {
	isTextLeaf: (e) => x.isText(e),
	...h,
	isBlock: (e) => h.isAncestor(e) && h.isElement(e) && e.class === "block",
	isText: (e) => h.isElement(e) && e.class === "text",
	isVoid: (e) => h.isElement(e) && e.class === "void",
	isInline: (e) => h.isElement(e) && e.class === "inline",
	isOfType: (e, t) => h.isElement(e) && e?.type === t,
	hasId: (e, t) => h.isElement(e) && e?.id === t
}, W = {
	...m,
	position: (e) => {
		let { selection: t } = e;
		if (!t) return -1;
		let n = m.unhangRange(e, t);
		return n && n.anchor.path.length ? n.anchor.path[0] : -1;
	},
	length: (e) => Array.from(m.nodes(e, {
		at: [],
		mode: "highest",
		match: (e) => h.isElement(e)
	})).length,
	parents: (e) => m.nodes(e, {
		at: [],
		mode: "highest",
		match: (e) => h.isElement(e)
	}),
	selectedTextEntries: (e) => {
		if (!b.isRange(e.selection)) return [];
		let t = m.nodes(e, {
			at: e.selection,
			match: (e) => x.isText(e)
		});
		return Array.from(t);
	},
	includes: (e, t) => {
		let { selection: n } = e;
		if (!n) return !1;
		let [r] = Array.from(m.nodes(e, {
			at: m.unhangRange(e, n),
			match: (e) => !m.isEditor(e) && h.isElement(e) && e.type === t
		}));
		return !!r;
	},
	getSelectedText: (e, t) => {
		let n = t || m.unhangRange(e, e.selection);
		return m.string(e, n);
	},
	replaceStringAtPosition: (e, t, n) => {
		if (!e.selection) return;
		let r = e.selection.anchor, [i] = m.node(e, r.path);
		if (!x.isText(i)) return;
		let a = r.offset - t.length;
		a < 0 && (a = 0);
		let o = -1, s = -1;
		for (; (a = i.text.indexOf(t, a)) !== -1;) {
			if (r.offset >= a && r.offset <= a + t.length) {
				o = a, s = a + t.length;
				break;
			}
			a += 1;
		}
		if (o === -1) return;
		let c = {
			anchor: {
				path: r.path,
				offset: o
			},
			focus: {
				path: r.path,
				offset: s
			}
		};
		S.insertText(e, n, { at: c });
	},
	insertAt(e, t, n) {
		(Array.isArray(n) ? n : [n]).length && S.insertNodes(e, n, { at: [t] });
	},
	hasText(e) {
		for (let [t] of e) for (let e of g.texts(t)) if (e[0].text.trim() !== "") return !0;
		return !1;
	},
	convertToTextNode(e, t, n = void 0) {
		if (!e.selection) return;
		let r = Array.from(m.nodes(e, {
			mode: "highest",
			at: m.unhangRange(e, e.selection),
			match: (e) => !m.isEditor(e)
		}));
		r.length && m.withoutNormalizing(e, () => {
			for (let i = 0; i < r.length; i++) {
				let [a, o] = r[i];
				if (!U.isOfType(a, "core/text") && U.isText(a)) {
					let r = a.id;
					S.removeNodes(e, { at: o });
					let i = g.string(a);
					S.insertNodes(e, {
						id: r,
						class: "text",
						type: t,
						properties: n ? { role: n } : {},
						children: [{ text: i }]
					}, { at: o }), e.select({
						anchor: {
							path: o.concat(0),
							offset: 0
						},
						focus: {
							path: o.concat(0),
							offset: 0
						}
					});
				} else U.isOfType(a, "core/text") && S.setNodes(e, {
					type: "core/text",
					properties: n ? { role: n } : {}
				}, { at: o });
			}
		});
	}
}, De = () => ({
	class: "text",
	name: "core/text",
	componentEntry: {
		class: "text",
		component: Oe,
		placeholder: "¶"
	},
	actions: [{
		name: "set-text",
		title: "Text",
		handler: ({ editor: e }) => {
			W.convertToTextNode(e, "core/text");
		},
		visibility: (e) => [
			e.type === "core/text",
			!0,
			e.type === "core/text" && !e?.properties?.role
		]
	}]
});
function Oe(e) {
	return /* @__PURE__ */ f(d, { children: e.children });
}
var ke = () => ({
	class: "leaf",
	name: "core/bold",
	actions: [{
		name: "toggle-bold",
		tool: () => /* @__PURE__ */ f("div", {
			style: { fontWeight: "bold" },
			children: "B"
		}),
		hotkey: "mod+b",
		handler: () => !0
	}],
	getStyle: () => ({ fontWeight: "bold" })
}), Ae = () => ({
	class: "leaf",
	name: "core/italic",
	actions: [{
		name: "toggle-italic",
		tool: () => /* @__PURE__ */ f("div", {
			style: { fontStyle: "italic" },
			children: "I"
		}),
		hotkey: "mod+i",
		handler: () => !0
	}],
	getStyle: () => ({ fontStyle: "italic" })
}), je = () => ({
	class: "leaf",
	name: "core/underline",
	actions: [{
		name: "toggle-underline",
		hotkey: "mod+u",
		tool: () => /* @__PURE__ */ f("div", {
			style: { textDecoration: "underline" },
			children: "U"
		}),
		handler: () => !0
	}],
	getStyle: () => ({ textDecoration: "underline" })
}), Me = () => ({
	class: "generic",
	name: "navigation",
	actions: [{
		name: "move-text-up",
		hotkey: "mod+option+up",
		handler: ({ editor: e }) => {
			let t = W.position(e);
			t < 1 || S.moveNodes(e, {
				at: [t],
				to: [t - 1]
			});
		}
	}, {
		name: "move-text-down",
		hotkey: "mod+option+down",
		handler: ({ editor: e }) => {
			let t = W.position(e), n = W.length(e);
			t < 0 || t + 1 === n || S.moveNodes(e, {
				at: [t],
				to: [t + 1]
			});
		}
	}]
}), Ne = [
	De,
	ke,
	Ae,
	je
], Pe = [Me], Fe = {
	menu: void 0,
	spelling: void 0,
	dispatch: () => {}
}, G = n(Fe), Ie = (e, t) => {
	let { menu: n, spelling: r } = t, i = {};
	return i.menu = n, i.spelling = r, {
		...e,
		...i
	};
};
function Le({ children: e }) {
	let [t, n] = c(Ie, { ...Fe }), r = {
		...t,
		dispatch: n
	};
	return /* @__PURE__ */ f(G.Provider, {
		value: r,
		children: e
	});
}
var Re = n(void 0);
function ze({ children: e }) {
	let t = l(void 0), n = l(/* @__PURE__ */ new Set()), i = D(), o = r((e) => (n.current.add(e), e(t.current), () => {
		n.current.delete(e);
	}), []), s = r(() => {
		n.current.forEach((e) => {
			e(t.current);
		});
	}, []), c = r(() => {
		let e = window.getSelection();
		if (!e || e.rangeCount === 0) {
			t.current = void 0, s();
			return;
		}
		let n = e.getRangeAt(0), { top: r, right: a, bottom: o, left: c, width: l, height: u, x: d, y: f } = n.getBoundingClientRect(), p;
		if (i && C.isFocused(i) && i.selection) try {
			let [e] = m.nodes(i, {
				at: i.selection,
				match: (e) => h.isElement(e) && m.isBlock(i, e)
			});
			if (e) {
				let [t] = e;
				p = C.toDOMNode(i, t).getBoundingClientRect();
			}
		} catch (e) {
			console.warn("Failed to get Slate element bounds:", e);
		}
		let g = {
			top: r,
			right: a,
			bottom: o,
			left: c,
			width: l,
			height: u,
			x: d,
			y: f,
			isCollapsed: n.collapsed,
			box: p
		};
		JSON.stringify(t.current) !== JSON.stringify(g) && (t.current = g, s());
	}, [s, i]);
	a(() => {
		c();
		let e = () => {
			requestAnimationFrame(() => {
				c();
			});
		}, t = () => {
			c();
		};
		return document.addEventListener("selectionchange", e, {
			capture: !0,
			passive: !0
		}), window.addEventListener("scroll", t, {
			capture: !0,
			passive: !0
		}), () => {
			document.removeEventListener("selectionchange", e, { capture: !0 }), window.removeEventListener("scroll", t, { capture: !0 });
		};
	}, [c]);
	let u = {
		boundsRef: t,
		subscribe: o
	};
	return /* @__PURE__ */ f(Re.Provider, {
		value: u,
		children: e
	});
}
function Be(e) {
	let t = Array.from(m.nodes(e, {
		at: [],
		match: (e, t) => h.isElement(e) && ["core/text"].includes(e.type || "") && e.properties?.role !== "vignette" && t.length === 1
	}));
	return {
		full: Ve(Array.from(m.nodes(e, {
			at: [],
			match: (e) => h.isElement(e) && ["text"].includes(e.class || "")
		}))),
		short: Ve(t)
	};
}
function Ve(e) {
	let t = 0, n = 0;
	for (let [r] of e) {
		let e = g.string(r).trim();
		t += (e.match(/\p{L}+/gu) || []).length, n += e.length;
	}
	return {
		words: t,
		characters: n
	};
}
var He = (e, t) => {
	let n, r = (...r) => {
		clearTimeout(n), n = setTimeout(() => {
			e(...r);
		}, t);
	};
	return r.force = (...t) => {
		clearTimeout(n), e(...t);
	}, r.cancel = () => {
		clearTimeout(n);
	}, r;
};
function Ue(e, t) {
	return e.lang = t || document?.documentElement?.lang || navigator.language || "en", e;
}
function We(e, t, n = 6125) {
	let { onChange: r } = e, i = null;
	return e.spellingLookupTable = /* @__PURE__ */ new Map(), e.onSpellcheckComplete = (e) => {
		i = e;
	}, e.spellcheck = He(async () => {
		if (!t) return;
		let [n, r, a] = await Ge(e, t, e.spellingLookupTable);
		n && r.length > 0 && (e.spellingLookupTable = a, i?.(a, r));
	}, n), e.onChange = (t) => {
		r(t), e.operations.filter((e) => [
			"insert_text",
			"remove_text",
			"split_node",
			"merge_node"
		].includes(e.type)).length && e.spellcheck && e.spellcheck();
	}, e;
}
async function Ge(e, t, n) {
	let r = /* @__PURE__ */ new Map(), i = [], a = [];
	for (let t of e.children) {
		if (!h.isElement(t) || !t.id) continue;
		let a = n.get(t.id), o = g.string(t);
		if (!a || a.text !== o) {
			let n = o.trim() === "";
			r.set(t.id, {
				lang: t.lang || e.lang,
				text: o,
				errors: [],
				check: !n
			}), n || i.push(t.id);
		} else r.set(t.id, {
			...a,
			check: !1
		});
	}
	if (!i.length) return [
		!1,
		[],
		r
	];
	let o = await t(Array.from(r.values()).filter((e) => e.check).map((e) => ({
		text: e.text,
		lang: e.lang
	})));
	if (o.length !== i.length) return console.warn("Number of spellchecked texts differ from requested number of texts to spellcheck"), [
		!1,
		[],
		r
	];
	for (let e = 0; e < i.length; e++) {
		let t = i[e], n = r.get(t);
		n && (n.errors = o[e].filter((e) => e?.text && Array.isArray(e?.suggestions)).map((e) => ({
			id: crypto.randomUUID(),
			text: e.text,
			level: e.level,
			suggestions: e.suggestions || []
		})), a.push(t));
	}
	return [
		!0,
		a,
		r
	];
}
function Ke(e) {
	let { isInline: t, isBlock: n, isVoid: r } = e;
	return e.isInline = (e) => h.isElement(e) && e.class === "inline" ? !0 : t(e), e.isBlock = (e) => h.isAncestor(e) && h.isElement(e) && e.class === "block" ? !0 : n(e), e.isVoid = (e) => h.isElement(e) && e.class === "void" ? !0 : r(e), e.isTextBlock = (e) => h.isElement(e) && e.class === "text", e.isOfType = (e, t) => h.isElement(e) && e?.type === t, e;
}
function qe(e, t, n) {
	let [r, i] = Je(t, n);
	return typeof r == "function" && new Promise((t) => {
		r({
			input: n,
			editor: e
		}).then((n) => {
			typeof n?.data == "object" && i === n.type ? (Ye(e, n.data), t()) : typeof n?.data == "string" && i === "text/plain" ? t(n?.data) : (console.warn("Unexpected output from consumer when handling paste", n), t());
		});
	});
}
function Je(e, t) {
	for (let n of e) {
		let [e, r] = n?.consumes({ input: t }) || [!1];
		if (e) return [n.consume, r];
	}
	return [void 0, void 0];
}
function Ye(e, t) {
	if (!b.isRange(e.selection)) return;
	let n = m.unhangRange(e, e.selection), r = n && n.anchor.path[0] > 0 ? n.anchor.path[0] : 0, i = g.get(e, [r]);
	h.isElement(i) && (i?.class === "text" && m.string(e, [r]) === "" ? S.removeNodes(e, { at: [r] }) : r++, S.insertNodes(e, t, {
		at: [r],
		select: !0
	}));
}
function Xe(e, t) {
	let { insertText: n } = e, r = t.filter((e) => H.isElementPlugin(e) && !!e.consumer?.consume && !!e.consumer?.consumes).map(({ consumer: e }) => e);
	return e.insertText = (t) => {
		let i = qe(e, r, {
			source: "text",
			type: "text/plain",
			data: t
		});
		if (!(i instanceof Promise)) {
			n(t);
			return;
		}
		i.then((e) => {
			n(typeof e == "string" ? e : t);
		});
	}, e;
}
function Ze(e, t, n) {
	let { normalizeNode: r } = e;
	return e.normalizeNode = (t) => {
		let [i, a] = t;
		if (!h.isElement(i)) return r(t);
		let o = n.get(i.type);
		if (!o) {
			if (a.length === 1 && !i.type && n.has("core/text") && nt(i)) {
				S.setNodes(e, {
					type: "core/text",
					class: "text",
					properties: {}
				}, { at: a });
				return;
			}
			return r(t);
		}
		Qe(e, t, o) || (typeof o.componentEntry.constraints?.normalizeNode != "function" || !0 !== o.componentEntry.constraints.normalizeNode(e, t)) && r(t);
	}, e;
}
function Qe(e, t, n) {
	let [r, i] = t;
	if (!h.isElement(r)) return !1;
	let a = n.componentEntry.children;
	if (!a || a.length === 0) return !1;
	let o = a.filter((e) => e.constraints?.min !== void 0 || e.constraints?.max !== void 0);
	if (o.length === 0) return !1;
	let s = n.type;
	for (let t of o) {
		let n = t.constraints?.max;
		if (n === void 0) continue;
		let a = $e(r, `${s}/${t.type}`);
		if (a.length > n) {
			let t = a[a.length - 1];
			return S.removeNodes(e, { at: [...i, t] }), !0;
		}
	}
	for (let t of o) {
		let n = t.constraints?.min;
		if (n === void 0) continue;
		let o = `${s}/${t.type}`;
		if ($e(r, o).length < n) {
			let n = et(r, a, t);
			return S.insertNodes(e, rt(t, o), { at: [...i, n] }), !0;
		}
	}
	let c = /* @__PURE__ */ new Map();
	a.forEach((e, t) => {
		e.type && c.set(`${s}/${e.type}`, t);
	});
	let l = r.children.map((e) => h.isElement(e) ? c.get(e.type) ?? Infinity : Infinity);
	for (let t = 1; t < l.length; t++) if (l[t] < l[t - 1]) {
		let n = 0;
		for (let e = 0; e < t; e++) {
			if (l[e] >= l[t]) {
				n = e;
				break;
			}
			n = e + 1;
		}
		return S.moveNodes(e, {
			at: [...i, t],
			to: [...i, n]
		}), !0;
	}
	return !1;
}
function $e(e, t) {
	let n = [];
	for (let r = 0; r < e.children.length; r++) {
		let i = e.children[r];
		h.isElement(i) && i.type === t && n.push(r);
	}
	return n;
}
function et(e, t, n) {
	let r = /* @__PURE__ */ new Map();
	t.forEach((e, t) => r.set(e.type, t));
	let i = r.get(n.type) ?? 0, a = 0;
	for (let n = 0; n < e.children.length; n++) {
		let r = e.children[n];
		h.isElement(r) && tt(r.type, t) < i && (a = n + 1);
	}
	return a;
}
function tt(e, t) {
	for (let n = 0; n < t.length; n++) {
		let r = t[n];
		if (r.type && e.endsWith(`/${r.type}`)) return n;
	}
	return Infinity;
}
function nt(e) {
	return e.children.every((e) => !h.isElement(e) || U.isInline(e));
}
function rt(e, t) {
	let n = {
		id: crypto.randomUUID(),
		type: t,
		children: [{ text: "" }]
	};
	switch (e.class) {
		case "void": return {
			...n,
			class: "void"
		};
		case "block": return {
			...n,
			class: "block"
		};
		case "text": return {
			...n,
			class: "text",
			properties: {}
		};
		default: return {
			...n,
			class: "text",
			properties: {}
		};
	}
}
function it(e, t) {
	let { isVoid: n } = e, r = [], i = [];
	return t.forEach((e) => {
		r.push(e.type), e.class === "void" && i.push(e.type);
	}), e.isVoid = (e) => i.includes(e.type) || !r.includes(e.type) ? !0 : n(e), e;
}
function at(e, t) {
	let { insertBreak: n } = e;
	return e.insertBreak = () => {
		if (!ot(e, t)) return;
		let { selection: r } = e;
		if (r && b.isCollapsed(r)) {
			let [, t] = m.node(e, r);
			for (let [n, r] of m.levels(e, { at: t })) if (!(r.length <= 1) && U.isBlock(n)) {
				S.splitNodes(e, {
					match: (e) => h.isElement(e),
					mode: "lowest",
					always: !0
				});
				return;
			}
		}
		let { isAtEnd: i, next: a } = ct(e) || {};
		if (i) {
			if (!st(e, t)) {
				n();
				return;
			}
			S.insertNodes(e, {
				id: crypto.randomUUID(),
				class: "text",
				type: "core/text",
				children: [{ text: "" }]
			}, a ? { at: a } : void 0), a && S.select(e, m.start(e, a));
			return;
		}
		n();
	}, e;
}
function ot(e, t) {
	let { selection: n } = e;
	if (!n) return !0;
	let r = b.isCollapsed(n) ? [n.anchor] : [n.anchor, n.focus];
	for (let n of r) for (let [r, i] of m.levels(e, { at: n })) {
		if (!h.isElement(r)) continue;
		let n = t.get(r.type);
		if (!n) continue;
		if (n.componentEntry?.constraints?.allowBreak === !1) return !1;
		let a = n.componentEntry?.constraints?.max;
		if (a !== void 0 && i.length > 1) {
			let t = i.slice(0, -1), [n] = m.node(e, t);
			if (h.isElement(n)) {
				let e = 0;
				for (let t of n.children) h.isElement(t) && t.type === r.type && e++;
				if (e >= a) return !1;
			}
		}
	}
	return !0;
}
function st(e, t) {
	let { selection: n } = e;
	if (!n) return !0;
	let r = b.isCollapsed(n) ? [n.anchor] : [n.anchor, n.focus];
	for (let n of r) for (let [r] of m.levels(e, { at: n })) if (h.isElement(r) && t.get(r.type)?.componentEntry?.constraints?.allowExitBreak === !1) return !1;
	return !0;
}
function ct(e) {
	let { selection: t } = e;
	if (!t || !b.isCollapsed(t)) return;
	let [n, r] = m.node(e, t);
	if (!x.isText(n)) return;
	let i = [r[0]], a = m.node(e, i), o = m.last(e, i);
	return {
		isAtEnd: m.isEnd(e, t.anchor, o?.[1] ?? r),
		next: U.isBlock(a[0]) ? v.next(a[1]) : void 0
	};
}
function lt(e, t) {
	return e.insertSoftBreak = () => {
		ut(e, t) && S.insertText(e, "\n");
	}, e;
}
function ut(e, t) {
	let { selection: n } = e;
	if (!n) return !1;
	let r = b.isCollapsed(n) ? [n.anchor] : [n.anchor, n.focus], i = !1;
	for (let n of r) for (let [r] of m.levels(e, { at: n })) {
		if (!h.isElement(r)) continue;
		let e = t.get(r.type)?.componentEntry?.constraints;
		if (e?.allowSoftBreak === !1) return !1;
		e?.allowSoftBreak === !0 && (i = !0);
	}
	return i;
}
function dt(e) {
	let { allowBreak: t, allowSoftBreak: n, normalizeNode: r, allowEdgeWhitespace: i, min: a, max: o } = e?.constraints ?? {};
	return {
		min: a,
		max: o,
		allowBreak: t ?? !0,
		allowSoftBreak: n ?? !1,
		allowEdgeWhitespace: i ?? !0,
		normalizeNode: r instanceof Function ? r : void 0
	};
}
var ft = "\xA0";
function pt(e) {
	return e && e.replace(/\s+/g, (e) => e.includes(ft) ? ft : " ");
}
function mt(e) {
	return e.replace(/\r\n|\r/g, "\n");
}
function ht(e, t, n) {
	let { selection: r } = e;
	if (!r) return !1;
	let i = b.edges(r);
	if (!b.isCollapsed(r) && v.compare(i[0].path, i[1].path) !== 0) return !1;
	let a = W.parent(e, r), o = a[0], { componentEntry: s = void 0 } = t.get(o.type) || {};
	if (!s || o.class !== "text") return !1;
	let c, { allowBreak: l } = dt(s);
	c = l ? mt(n).replace(/\n{2,}/g, "\n").trim().split("\n").map((e) => e.trim()) : [pt(n)];
	let u = "core/text", d;
	a[1].length > 1 && (u = o.type, d = o.properties);
	let f = c.map((e) => ({
		id: crypto.randomUUID(),
		type: u,
		class: "text",
		children: [{ text: e }],
		properties: d
	})), p = f.shift();
	return p && S.insertFragment(e, [p]), S.insertNodes(e, f), !0;
}
function gt(e) {
	let { selection: t } = e;
	return Array.from(m.nodes(e, {
		at: m.unhangRange(e, t),
		match: (e) => !m.isEditor(e) && h.isElement(e) && [
			"block",
			"void",
			"text",
			"textblock"
		].includes(e.class || "")
	}));
}
function _t(e) {
	return gt(e).map((e) => e[0]);
}
function vt(e, t) {
	try {
		if (C.hasDOMNode(e, t)) {
			let n = C.toSlateNode(e, t);
			return [n, C.findPath(e, n)];
		}
	} catch (e) {
		console.warn(e);
	}
}
function yt(e, t) {
	let n, r;
	if (document.caretPositionFromPoint) {
		let e = document.caretPositionFromPoint(t.clientX, t.clientY);
		n = e?.offsetNode, r = e?.offset ?? 0;
	} else if (document.caretRangeFromPoint) {
		let e = document.caretRangeFromPoint(t.clientX, t.clientY);
		n = e?.startContainer, r = e?.startOffset ?? 0;
	} else return;
	if (!n || n?.nodeType !== 3) return;
	let i = C.findEventRange(e, t), a = i.anchor.offset <= i.focus.offset, o = n.nodeValue?.length || 0;
	return {
		anchor: {
			path: i.anchor.path,
			offset: i.anchor.offset + (a ? -r : o - r)
		},
		focus: {
			path: i.focus.path,
			offset: i.focus.offset + (a ? o - r : -r)
		}
	};
}
function bt(e, t, n) {
	let { insertData: r, insertText: i } = e, a = n.filter((e) => H.isElementPlugin(e) && !!e.consumer?.consume && !!e.consumer?.consumes).map(({ consumer: e }) => e);
	e.insertData = (n) => {
		let { types: o } = n, { selection: s } = e, c = !0;
		if (s && b.isCollapsed(s)) {
			let n = _t(e), r = n.length && n[n.length - 1];
			h.isElement(r) && (c = t.get(r.type || "")?.componentEntry.constraints?.allowBreak ?? !0);
		}
		if (c && o.includes("application/x-slate-fragment")) return r(n);
		let l = qe(e, a, {
			source: "html",
			type: "text/html",
			data: n
		});
		if (l instanceof Promise) {
			l.then((e) => {
				if (typeof e == "string") return i(e);
			});
			return;
		}
		if (o.includes("text/plain")) {
			let r = n.getData("text/plain"), i = /\n{2,}/.test(mt(r));
			if (r && (!c || o.includes("text/html") || i) && ht(e, t, r)) return;
		}
		r(n);
	};
}
function xt(e) {
	let { apply: t } = e;
	return e.apply = (n) => {
		if (n.type === "insert_node") {
			let r = St(e, n.node);
			if (r) return t({
				...n,
				node: r
			});
		}
		if (n.type === "split_node") {
			let r = n.properties;
			if ("id" in r && typeof r.id == "string" && wt(e, r)) return t({
				...n,
				properties: {
					...n.properties,
					id: crypto.randomUUID()
				}
			});
		}
		t(n);
	}, e;
}
function St(e, t) {
	if (!h.isElement(t)) return null;
	let n = Ct(e), r = !1, i = structuredClone(t), a = (e) => {
		if (h.isElement(e)) {
			(!e.id || n.has(e.id)) && (e.id = crypto.randomUUID(), r = !0), n.add(e.id);
			for (let t of e.children) a(t);
		}
	};
	return a(i), r ? i : null;
}
function Ct(e) {
	let t = /* @__PURE__ */ new Set();
	for (let [n] of m.nodes(e, {
		at: [],
		mode: "all"
	})) !m.isEditor(n) && h.isElement(n) && typeof n.id == "string" && t.add(n.id);
	return t;
}
function wt(e, t) {
	return t.id ? Array.from(m.nodes(e, {
		at: [],
		mode: "all",
		match: (e) => !m.isEditor(e) && h.isElement(e) && e.id === t.id
	})).length > 0 : !1;
}
function Tt(e) {
	let { deleteBackward: t, deleteForward: n } = e;
	return e.deleteBackward = (n) => {
		let { selection: r } = e;
		if (r && Et(e)) {
			let [i] = m.nodes(e, {
				match: (t) => h.isElement(t) && m.isBlock(e, t),
				at: r
			});
			if (!i) return t(n);
			let [a, o] = i, s = g.string(a), c = m.first(e, o);
			if (c && U.isBlock(a) && v.equals(r.focus.path, c[1]) && r.focus.offset === 0) return;
			if (!s.length && o[0] === 0) {
				e.children.length > 1 && S.removeNodes(e, { at: o });
				return;
			}
			let l = v.next(o);
			if (!s.length && l[0] >= e.children.length) {
				S.removeNodes(e, { at: o });
				return;
			}
			if (o[0] > 0) {
				let t = v.previous(o), n = m.node(e, t);
				if (n) {
					let [r] = n;
					if (h.isElement(r) && r.class === "block") {
						s.length ? S.removeNodes(e, { at: t }) : (S.removeNodes(e, { at: o }), S.select(e, m.end(e, t)));
						return;
					}
				}
			}
		}
		t(n);
	}, e.deleteForward = (t) => {
		let { selection: r } = e;
		if (r && Dt(e)) {
			let [i] = m.nodes(e, {
				match: (t) => h.isElement(t) && m.isBlock(e, t),
				at: r
			});
			if (!i) return n(t);
			let [a, o] = i, s = g.string(a);
			if (!s.length && o[0] === 0 && e.children.length > 1) {
				S.removeNodes(e, { at: o });
				return;
			}
			if (o[0] < e.children.length - 1) {
				let [t, n] = m.node(e, [o[0] + 1]);
				if (h.isElement(t) && t.class === "block") {
					s.length ? S.removeNodes(e, { at: n }) : (S.removeNodes(e, { at: o }), S.select(e, m.end(e, [o[0] - 1])));
					return;
				}
			}
		}
		n(t);
	}, e;
}
function Et(e) {
	let { selection: t } = e;
	if (!t || !b.isCollapsed(t)) return !1;
	let [n, r] = m.node(e, t);
	if (!x.isText(n)) return !1;
	let i = [r[0]], a = m.first(e, i);
	return m.isStart(e, t.anchor, a?.[1] ?? r);
}
function Dt(e) {
	let { selection: t } = e;
	if (!t || !b.isCollapsed(t)) return !1;
	let [n, r] = m.node(e, t);
	if (!x.isText(n)) return !1;
	let i = [r[0]], a = m.last(e, i);
	return m.isEnd(e, t.anchor, a?.[1] ?? r);
}
function Ot(e, t) {
	let { insertFragment: n } = e;
	return e.insertFragment = (r, i) => {
		let { selection: a } = e;
		if (!a) {
			n(r, i);
			return;
		}
		if (r.length === 1 && kt(r[0])) {
			let e = jt(r[0]);
			e.length && n(e, i);
			return;
		}
		if (!r.every(U.isText) && Pt(e, a, t)) {
			let t = r.map((e) => g.string(e)).join("\n");
			e.insertText(t);
			return;
		}
		if (!r.every(U.isText)) {
			let t = a.anchor, o = a.focus;
			if (t.path[0] === o.path[0]) {
				let n = t.path[0], i = e.children[n];
				if (h.isElement(i) && i.class === "text") {
					b.isCollapsed(a) || S.delete(e);
					let t = e.selection.anchor, i = y.equals(t, m.start(e, [n])), o = y.equals(t, m.end(e, [n])), s = !i && !o, c = i ? n : n + 1;
					m.withoutNormalizing(e, () => {
						s && S.splitNodes(e, {
							at: t,
							match: (e, t) => t.length === 1
						});
						for (let t = 0; t < r.length; t++) S.insertNodes(e, r[t], { at: [c + t] });
					}), S.select(e, m.end(e, [c + r.length - 1]));
					return;
				}
			}
			n(r, i);
			return;
		}
		let [o, s] = b.edges(a), c = v.equals(o.path, s.path) ? s : Mt(e, s), [l] = Nt(e, o.path, c.path) ?? [];
		if (!U.isText(l)) {
			n(r, i);
			return;
		}
		if (g.string(l)?.length && b.isCollapsed(a)) {
			n(r, i);
			return;
		}
		let u = r.map((e) => {
			if (e.type === l.type && e.properties?.role === l.properties?.role) return e;
			let t = { ...e };
			return t.properties ? t.properties.role = l.properties?.role : t.properties = { role: l.properties?.role }, t;
		});
		n(u, i);
	}, e;
}
function kt(e) {
	return !h.isElement(e) || e.class === "text" ? !1 : At(e);
}
function At(e) {
	return x.isText(e) ? !0 : !h.isElement(e) || e.class === "void" ? !1 : e.class === "text" ? e.children.every((e) => x.isText(e)) : e.children.length === 1 && At(e.children[0]);
}
function jt(e) {
	return x.isText(e) ? [e] : h.isElement(e) ? e.children.flatMap(jt) : [];
}
function Mt(e, t) {
	if (t.offset !== 0 || t.path[0] === 0) return t;
	try {
		let n = m.start(e, [t.path[0]]);
		if (y.equals(t, n)) return m.end(e, [t.path[0] - 1]);
	} catch (e) {
		console.trace(e);
	}
	return t;
}
function Nt(e, t, n) {
	let r = v.equals(t, n) ? t : v.common(t, n);
	for (; r.length > 0;) try {
		let [t] = m.node(e, r);
		if (h.isElement(t) && t.class === "text") return [t, r];
		r = r.slice(0, -1);
	} catch (e) {
		console.trace(e);
	}
	return null;
}
function Pt(e, t, n) {
	let r = t.anchor.path;
	if (r.length <= 1) return !1;
	for (let t = r.length - 1; t >= 1; t--) {
		let i = r.slice(0, t);
		try {
			let [t] = m.node(e, i);
			if (!h.isElement(t)) continue;
			if (t.class !== "text") return !1;
			let r = n.get(t.type);
			return r ? r.parent !== null : !1;
		} catch {
			return !1;
		}
	}
	return !1;
}
function Ft(e) {
	let { insertText: t } = e;
	return e.insertText = (n) => {
		if (e.allowEdgeWhitespace === !1 && /^[\t\n\r\f\v ]+$/.test(n)) {
			let { selection: t } = e;
			if (t && b.isCollapsed(t)) {
				for (let [n, r] of m.levels(e, { at: t.anchor })) if (!(!h.isElement(n) || r.length !== 1) && m.isStart(e, t.anchor, r)) return;
			}
		}
		t(n);
	}, e;
}
function K(e) {
	let { selection: t } = e;
	if (!t || b.isCollapsed(t)) return !1;
	let n = It(e, t.anchor.path), r = It(e, t.focus.path);
	return !(n === void 0 && r === void 0 || n && r && v.equals(n, r));
}
function It(e, t) {
	return m.above(e, {
		at: t,
		match: (e) => h.isElement(e) && U.isBlock(e)
	})?.[1];
}
function Lt(e, t) {
	m.withoutNormalizing(e, () => {
		let n = Array.from(m.nodes(e, {
			at: t,
			match: (e) => x.isText(e)
		})).reverse();
		for (let [, r] of n) {
			let n = b.intersection(t, m.range(e, r));
			n && !b.isCollapsed(n) && S.delete(e, { at: n });
		}
	});
}
function Rt(e) {
	let { insertText: t, insertFragment: n, insertData: r, insertBreak: i, insertSoftBreak: a, deleteFragment: o } = e;
	return e.insertText = (n, r) => {
		if (K(e)) {
			zt(e, () => t(n, r));
			return;
		}
		t(n, r);
	}, e.insertData = (n) => {
		if (K(e)) {
			if (n.types.includes("application/x-slate-fragment")) return;
			let r = n.getData("text/plain");
			r && zt(e, () => t(r));
			return;
		}
		r(n);
	}, e.insertFragment = (t, r) => {
		K(e) || n(t, r);
	}, e.insertBreak = () => {
		K(e) || i();
	}, e.insertSoftBreak = () => {
		K(e) || a();
	}, e.deleteFragment = (t) => {
		if (K(e)) {
			let { selection: t } = e;
			if (t) {
				let n = m.pointRef(e, t.focus);
				Lt(e, t);
				let r = n.unref();
				r && S.select(e, r);
			}
			return;
		}
		o(t);
	}, e;
}
function zt(e, t) {
	let { selection: n } = e;
	if (!n) return;
	let r = m.pointRef(e, n.focus);
	Lt(e, n);
	let i = r.unref();
	i && (S.select(e, i), t());
}
function Bt(e) {
	let { apply: t } = e;
	return e.apply = (n) => {
		t(n);
		let r = e.selection;
		r && (!Vt(e, r.anchor.path) || !Vt(e, r.focus.path)) && (console.warn("[textbit] Cleared stale selection that pointed outside the document.", {
			selection: r,
			op: n
		}), S.deselect(e));
	}, e;
}
function Vt(e, t) {
	let n = e;
	for (let e = 0; e < t.length; e++) {
		let r = t[e];
		if (r < 0 || r >= n.children.length) return !1;
		let i = n.children[r];
		if (e === t.length - 1) return !0;
		if (!h.isElement(i)) return !1;
		n = i;
	}
	return !0;
}
function Ht(e) {
	let { children: t, value: n, readOnly: i } = e, { debounce: o, spellcheckDebounce: c, dispatch: u, lang: d } = J(), { plugins: p, components: m } = q(), h = l(null), _ = l(Symbol("textbit-editor"));
	if (!h.current) {
		let t = O(ee());
		Wt(e) ? (t = F(ae(t, e.value, { localOrigin: _.current })), j.isYjsEditor(t) && Gt(e) && (t = P(t, e.awareness, {
			autoSend: e.cursor?.autoSend ?? !0,
			data: e.cursor?.data ?? void 0,
			cursorStateField: e.cursor?.stateField,
			cursorDataField: e.cursor?.dataField
		}))) : t = le(t), Ue(t, d), e.onSpellcheck && !i && We(t, e.onSpellcheck, c), Ke(t), Xe(t, p), Ot(t, m), Ze(t, p, m), it(t, m), Ft(t), at(t, m), lt(t, m), bt(t, m, p), xt(t), Tt(t), Rt(t), Bt(t), h.current = t;
	}
	let v = h.current;
	a(() => {
		if (j.isYjsEditor(v)) return j.connect(v), () => {
			j.disconnect(v);
		};
	}, [v]);
	let y = s(() => n instanceof k.XmlText ? [] : typeof n == "string" ? Ut(n) : n, [n]), b = r((t) => {
		e.onChange && (qt(e) || Wt(e) ? e.onChange(t) : Kt(e) && e.onChange(t.map((e) => g.string(e)).join("\n"))), u({ stats: Be(v) });
	}, [
		e.onChange,
		e.value,
		u
	]), x = s(() => i ? () => {} : He(b, o || 1250), [
		b,
		i,
		o
	]);
	return a(() => (v.spellcheck?.force(), u({ stats: Be(v) }), () => {
		v.spellcheck?.cancel();
	}), [v, u]), /* @__PURE__ */ f(ne, {
		editor: v,
		initialValue: y,
		onChange: x,
		children: t
	});
}
function Ut(e) {
	return e.split("\n").map((e) => ({
		id: crypto.randomUUID(),
		type: "core/text",
		class: "text",
		children: [{ text: e }]
	}));
}
function Wt(e) {
	return e.value instanceof k.XmlText;
}
function Gt(e) {
	return e.value instanceof k.XmlText && "awareness" in e && e.awareness != null;
}
function Kt(e) {
	return typeof e.value == "string";
}
function qt(e) {
	return !Wt(e) && !Kt(e);
}
var Jt = n({
	triggerRef: void 0,
	updateTriggerRef: () => {}
});
function Yt({ children: e }) {
	let t = l(void 0), n = r((e) => {
		t.current = e;
	}, []);
	return /* @__PURE__ */ f(Jt.Provider, {
		value: {
			triggerRef: t,
			updateTriggerRef: n
		},
		children: e
	});
}
function Xt(e) {
	let { children: t, verbose: n, readOnly: r, debounce: i, spellcheckDebounce: a, placeholders: o, plugins: s, className: c, style: l, placeholder: u } = e, d = {
		boxSizing: "border-box",
		textRendering: "optimizeLegibility",
		WebkitFontSmoothing: "antialiased",
		MozOsxFontSmoothing: "grayscale",
		...l
	};
	return /* @__PURE__ */ f("div", {
		className: c,
		style: d,
		children: /* @__PURE__ */ f(he, {
			verbose: !!n,
			readOnly: r,
			collaborative: !r && Zt(e),
			debounce: i,
			spellcheckDebounce: a,
			placeholders: o,
			placeholder: u,
			dir: e.dir,
			lang: e.lang,
			children: /* @__PURE__ */ f(we, {
				verbose: !!n,
				plugins: [...Pe.map((e) => e()), ...Array.isArray(s) && s.length ? s : Ne.map((e) => e())],
				children: /* @__PURE__ */ f(Ht, {
					...e,
					children: /* @__PURE__ */ f(ze, { children: /* @__PURE__ */ f(Le, { children: /* @__PURE__ */ f(Yt, { children: t }) }) })
				})
			})
		})
	});
}
function Zt(e) {
	return e.value instanceof k.XmlText && "awareness" in e && e.awareness != null;
}
var Qt = "\xA0";
function $t(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function en(e, t, n, r, i, a, o) {
	let [s, c] = n, l = [];
	if (t?.size && x.isText(s)) {
		let [n] = m.node(e, [c[0]]);
		if (h.isElement(n) && n.id) {
			let e = t.get(n.id);
			if (e?.errors.length) {
				let t = s.text;
				e.errors.forEach((e) => {
					let n = $t(e.text), r = RegExp(`(?<!\\p{L})${n}(?!\\p{L})`, "giu");
					[...t.matchAll(r)].forEach((t) => {
						t.index !== void 0 && l.push({
							anchor: {
								path: c,
								offset: t.index
							},
							focus: {
								path: c,
								offset: t.index + e.text.length
							},
							spellingError: e
						});
					});
				});
			}
		}
	}
	if (x.isText(s)) for (let e = 0; e < s.text.length; e++) {
		let t = s.text[e];
		t === "\n" ? l.push({
			anchor: {
				path: c,
				offset: e
			},
			focus: {
				path: c,
				offset: e + 1
			},
			newline: !0
		}) : t === Qt && l.push({
			anchor: {
				path: c,
				offset: e
			},
			focus: {
				path: c,
				offset: e + 1
			},
			nonBreakingSpace: !0
		});
	}
	if (c.length === 2 && x.isText(s) && !s.text && i !== "none") {
		let t = g.parent(e, c);
		if (h.isElement(t) && g.string(t) === "") {
			let n = t.id === e.children[0].id;
			if (i === "multiple" || i === "single" && n && o !== !1) {
				let e = r.get(t.type)?.componentEntry?.placeholder, n = i === "single" ? a : typeof e == "function" ? e(t) : e ?? "";
				l.push({
					anchor: {
						path: c,
						offset: 0
					},
					focus: {
						path: c,
						offset: 0
					},
					placeholder: n
				});
			}
		}
	}
	return l;
}
function tn({ attributes: e, children: t, element: n, entry: r, rootNode: i, options: a }) {
	let o = D(), s = n.lang || o.lang, c = typeof n.properties?.role == "string" && n.properties.role.length > 0 ? n.properties.role : null;
	if (!r.asOwnElement) {
		let { component: l } = r;
		return /* @__PURE__ */ f("div", {
			lang: s,
			"data-id": n.id,
			"data-type": n.type,
			...c ? { "data-role": c } : {},
			...e,
			children: /* @__PURE__ */ f(l, {
				element: n,
				rootNode: i,
				options: a,
				editor: o,
				children: t
			})
		});
	}
	let { component: l } = r, u = {
		...e,
		lang: s,
		"data-id": n.id,
		"data-type": n.type,
		...c ? { "data-role": c } : {}
	};
	return /* @__PURE__ */ f(l, {
		element: n,
		attributes: u,
		rootNode: i,
		options: a,
		editor: o,
		children: t
	});
}
var nn = n({
	dragOver: !1,
	onDragEnter: () => {},
	onDragLeave: () => {},
	onDrop: () => {},
	setOffset: () => {}
});
function rn(e, t, n) {
	let r = [], i = n.target.files;
	if (!i) return;
	for (let e of i) {
		let t = {
			kind: "file",
			type: e.type,
			name: e.name,
			source: "fileinput",
			input: e,
			consumer: [],
			output: void 0
		};
		r.push(t);
	}
	sn(t, r);
	let a = on(r), o = 0, s = gt(e);
	if (s) {
		let [, e] = s[s.length - 1];
		o = e[0] + 1;
	} else o = Array.from(m.nodes(e, {
		at: [0],
		match: (e) => !m.isEditor(e) && h.isElement(e)
	})).length;
	ln(e, a, t, n, o);
}
function an(e, t, n, r) {
	let i = n.dataTransfer, a = cn(i);
	sn(t, a), ln(e, on(a), t, n, r);
}
function on(e) {
	let t = [];
	return e.forEach((e) => {
		let n = t.find((t) => t.consumer.find((t) => !!e.consumer.find((e) => e.name === t.name)));
		n ? (e.consumer.forEach((e) => {
			n.consumer.find((t) => t.name === e.name) || n.consumer.push(e);
		}), n.pipe.push(e)) : t.push({
			consumer: e.consumer,
			pipe: [e]
		});
	}), t;
}
function sn(e, t) {
	for (let n of t) {
		let { source: t, type: r, input: i } = n;
		e.forEach((e) => {
			if (!H.isElementPlugin(e) || typeof e.consumer?.consumes != "function") return !1;
			let [a, o = void 0, s = !1] = e.consumer.consumes({ input: {
				source: t,
				type: r,
				data: i
			} });
			a === !0 && n.consumer.push({
				name: e.name,
				produces: o || void 0,
				aggregate: s
			});
		});
	}
}
function cn(e) {
	let t = [], n = !0;
	e.types.includes("text/plain") && (e.types.includes("text/uri-list") || e.types.includes("text/html")) && (n = !1);
	for (let r = 0; r < e.items.length; r++) {
		let i = e.items[r];
		i.kind === "file" ? t.push(mn("drop", i)) : i.type === "text/uri-list" ? t.push(...hn("drop", e, i, !n)) : i.type === "text/html" ? t.push(pn("drop", e, i, !n)) : i.type === "text/plain" ? n && t.push(fn("drop", e, i)) : t.push(fn("drop", e, i));
	}
	return t;
}
async function ln(e, t, n, r, i) {
	if (t.length) {
		r.preventDefault(), r.stopPropagation();
		let a = 0;
		for (let r of t) {
			if (r.consumer.length === 0) {
				if (r.pipe.find((e) => e.type === "textbit/droppable-id")) gn(e, r.pipe[0].input, i);
				else {
					let e = r.pipe.map((e) => e.type).join(", ");
					console.warn(`Ignored dropped data/files of type ${e}`);
				}
				continue;
			}
			a += await un(r, e, n, i, a);
		}
	}
}
async function un(e, t, n, r, i) {
	let a = e.consumer[0], o = n.find((e) => H.isElementPlugin(e) && e.name === a.name), s = o?.consumer?.consume || void 0, c = a?.produces;
	if (!o || !s) return console.warn(`Could not find plugin <${a.name}> or it's consume() function to handle pipe item from $(pipeItem.source})`), 0;
	let l = 0;
	if (a.aggregate) dn(s, e.pipe.map((e) => ({
		source: e.source,
		type: e.type,
		data: e.input
	})), c, t, r + i), l++;
	else for (let n of e.pipe) dn(s, {
		source: n.source,
		type: n.type,
		data: n.input
	}, c, t, r + i + l), l++;
	return l;
}
async function dn(e, t, n, r, i) {
	let a = m.pathRef(r, [i]), o = r.pendingDrops?.start({
		pathRef: a,
		kind: n
	}), s = () => {
		o && r.pendingDrops?.end(o), a.unref();
	}, c;
	try {
		c = await e({
			input: t,
			editor: r
		});
	} catch (e) {
		console.warn(e.message), s();
		return;
	}
	if (c === void 0) {
		s();
		return;
	}
	if (typeof c != "object" || !c || c.type !== n || c.data === void 0) {
		console.warn(`consume(): unexpected result for "${n}"; discarding.`, c), s();
		return;
	}
	let l = a.current;
	if (!l) {
		console.warn(`Drop position for "${n}" was removed before consume() resolved; dropping the consumed result.`), s();
		return;
	}
	let u = c.data;
	S.insertNodes(r, u, {
		at: l,
		select: !1
	}), s();
}
function fn(e, t, n) {
	return {
		kind: n.kind,
		type: n.type,
		source: e,
		input: t.getData(n.type),
		consumer: [],
		output: void 0
	};
}
function pn(e, t, n, r) {
	return {
		kind: n.kind,
		type: n.type,
		source: e,
		input: t.getData(n.type),
		alternate: r ? t.getData("text/plain") : void 0,
		consumer: [],
		output: void 0
	};
}
function mn(e, t) {
	return {
		kind: t.kind,
		type: t.type,
		source: e,
		input: t.getAsFile(),
		consumer: [],
		output: void 0
	};
}
function hn(e, t, n, r) {
	let i = t.getData(n.type), a = [], o = r ? t.getData("text/plain") : void 0;
	for (let t of i.split("\r\n")) a.push({
		kind: n.kind,
		type: n.type,
		source: e,
		input: t,
		alternate: o,
		consumer: [],
		output: void 0
	});
	return a;
}
function gn(e, t, n) {
	let r = 0, i;
	for (let n of e.children) {
		if (h.isElement(n) && n.id === t) {
			i = n;
			break;
		}
		r++;
	}
	i && S.moveNodes(e, {
		at: [r],
		to: [n]
	});
}
function q() {
	let e = i(Se);
	if (!e) throw Error("useTextbit must be used within a PluginRegistryContextProvider");
	return e;
}
var J = () => {
	let e = i(pe);
	if (!e) throw Error("useTextbit must be used within a TextbitProvider");
	return e;
};
function _n(e) {
	let t = e.target;
	for (; t && t !== e.currentTarget;) {
		if (t.getAttribute("draggable") === "true") return !0;
		t = t.parentElement;
	}
	return !1;
}
function vn(e, t) {
	let n = C.findEventRange(e, t);
	if (!b.isRange(n)) return !1;
	let r = n.anchor.path;
	do {
		let t = g.get(e, r);
		if (h.isElement(t) && t.class === "text") return !1;
		r = r.slice(0, -1);
	} while (r.length > 0);
	return !0;
}
function yn({ children: e, element: t }) {
	let { readOnly: n } = J(), a = D(), o = i(nn), { plugins: s } = q(), c = l(null), u = s.find((e) => e.name === t?.type), d = H.isElementPlugin(u) && !!u?.componentEntry?.droppable, p = r((e) => {
		if (!(n || !t?.id)) {
			if (!_n(e) && !vn(a, e)) {
				e.stopPropagation(), e.preventDefault();
				return;
			}
			e.stopPropagation(), c?.current && xn(c.current, e, t.id);
		}
	}, [
		n,
		t?.id,
		a
	]), m = r((e) => !n && (e.preventDefault(), e.stopPropagation(), !0), [n]), h = r((e) => {
		m(e) && o?.onDragEnter();
	}, [o, m]), g = r((e) => {
		m(e) && o?.onDragLeave();
	}, [o, m]), _ = r((e) => {
		m(e) && o.setOffset(Cn(e, c?.current, d));
	}, [
		o,
		m,
		d
	]), v = r((e) => {
		if (n) {
			e.preventDefault();
			return;
		}
		if (o?.onDrop && o.onDrop(e), !c.current || !t?.id) return;
		let r = Sn(a, e, c.current, t.id, d);
		r && an(a, s, e, r[0]);
	}, [
		o,
		t?.id,
		a,
		d,
		s,
		c,
		n
	]), y = r(() => {
		n || (o?.onDragLeave(), c?.current && (c.current.style.opacity = "1", bn()));
	}, [n, o]);
	return /* @__PURE__ */ f("div", {
		"data-id": t?.id || "",
		ref: c,
		draggable: !n && ["block", "void"].includes(t?.class || "") ? "true" : "false",
		onDragStartCapture: p,
		onDragEnterCapture: h,
		onDragLeaveCapture: g,
		onDragOverCapture: _,
		onDropCapture: v,
		onDragEnd: y,
		children: e
	});
}
function bn() {
	let e = document.getElementsByClassName("textbit-dragged-temp");
	if (e.length) for (let t of e) t.parentNode && t.parentNode.removeChild(t);
}
function xn(e, t, n) {
	let r = e.cloneNode(!0), { left: i, top: a } = e.getBoundingClientRect(), o = r.firstChild;
	o.style.transform = "scale(0.6) rotate(2deg)", r.style.width = `${e.offsetWidth}px`, r.style.height = `${e.offsetHeight}px`, r.style.position = "absolute", r.style.top = "-9999px", r.classList.add("textbit-dragged-temp"), document.body.appendChild(r), e.style.opacity = "0.5", t.dataTransfer.clearData(), t.dataTransfer.setData("textbit/droppable-id", n), t.dataTransfer.setDragImage(r, t.clientX - i, t.clientY - a);
}
function Sn(e, t, n, r, i) {
	let a = e.children.findIndex((e) => h.isElement(e) && e.id === r);
	return a < 0 ? null : [a + (Cn(t, n, i)?.position?.[0] === "above" ? 0 : 1), e.children[a]];
}
function Cn(e, t, n) {
	if (!t) return;
	let r = t.getBoundingClientRect(), i = e.clientY;
	if (e.clientX < r.left || e.clientX > r.right) return {
		position: void 0,
		bbox: r
	};
	let a = (i - r.top) / r.height * 100, o;
	return o = a <= 20 ? ["above", !1] : a <= 50 ? ["above", n] : a >= 80 ? ["below", n] : ["below", !1], {
		position: o,
		bbox: r
	};
}
var wn = n(null);
function Tn() {
	return i(wn);
}
var En = n(null);
function Dn() {
	return i(En);
}
function On(e) {
	let t = re(), n = D(), r = Tn(), i = Dn(), { element: a, attributes: o, entry: s } = e;
	if (s.asOwnElement) return null;
	let c = (() => {
		if (!i) return !1;
		let e = n.children.findIndex((e) => e === a);
		if (e === -1) return !1;
		let t = Math.min(i.anchorIndex, i.focusIndex), r = Math.max(i.anchorIndex, i.focusIndex);
		return e >= t && e <= r;
	})(), l = r && r.blockId === a.id ? r.direction : null, u = typeof a.properties?.role == "string" && a.properties.role.length > 0 ? a.properties.role : null, d = {
		position: "absolute",
		top: 0,
		bottom: 0,
		insetInlineEnd: -5,
		width: 1,
		backgroundColor: "currentColor",
		pointerEvents: "none",
		animation: "block-caret-blink 1s step-end infinite"
	}, m = l === "before" ? "before" : l === "after" ? "after" : t ? "active" : "inactive";
	return /* @__PURE__ */ f(yn, {
		element: a,
		children: /* @__PURE__ */ p("div", {
			lang: e.element.lang || n.lang,
			"data-id": a.id,
			"data-type": a.type,
			...u ? { "data-role": u } : {},
			"data-state": m,
			...c ? { "data-block-selected": "" } : {},
			className: `${a.class} ${a.type} ${s.class} relative group`,
			style: {
				position: "relative",
				...c ? { userSelect: "none" } : {}
			},
			...o,
			children: [
				/* @__PURE__ */ f(s.component, {
					element: a,
					options: e.options,
					editor: n,
					children: e.children
				}),
				a.class !== "text" && a.class !== "inline" && /* @__PURE__ */ f("div", {
					contentEditable: !1,
					className: "tb-focus-ring",
					style: {
						position: "absolute",
						inset: 0,
						pointerEvents: "none"
					}
				}),
				c && /* @__PURE__ */ f("div", {
					contentEditable: !1,
					className: "tb-block-selected",
					style: {
						position: "absolute",
						inset: -2,
						pointerEvents: "none",
						outline: "2px solid Highlight",
						outlineOffset: "2px",
						borderRadius: "var(--tb-focus-ring-radius, 5px)"
					}
				}),
				l === "before" && /* @__PURE__ */ f("div", {
					"aria-hidden": !0,
					style: {
						...d,
						insetInlineEnd: "unset",
						insetInlineStart: -5
					}
				}),
				l === "after" && /* @__PURE__ */ f("div", {
					"aria-hidden": !0,
					style: d
				})
			]
		})
	});
}
function kn({ attributes: e, children: t, element: n, entry: r, options: i }) {
	let a = D();
	return r.asOwnElement ? null : /* @__PURE__ */ f("span", {
		className: `inline ${r.type}`,
		"data-id": n.id,
		"data-type": n.type,
		...e,
		children: /* @__PURE__ */ f(r.component, {
			element: n,
			options: i,
			editor: a,
			children: t
		})
	});
}
function An({ element: e, attributes: t, children: n }) {
	return /* @__PURE__ */ f(yn, { children: /* @__PURE__ */ p("div", {
		contentEditable: !1,
		className: "textbit-parent textbit-unknown",
		"data-id": e.id,
		"data-type": e.type,
		...t,
		children: [/* @__PURE__ */ p("pre", {
			style: { fontSize: "80%" },
			children: [
				" ",
				"UNKNOWN OBJECT(",
				e.type,
				")"
			]
		}), /* @__PURE__ */ f("div", {
			style: { opacity: "0.4" },
			children: n
		})]
	}) });
}
function jn(e) {
	let t = D(), { element: n } = e, { components: r } = q(), i = r.get(n.type);
	if (!i) return /* @__PURE__ */ f(An, { ...e });
	let a = C.findPath(t, n);
	if (a.length === 1) return /* @__PURE__ */ f(On, {
		...e,
		entry: i.componentEntry,
		options: i.pluginOptions
	});
	if (i.class === "inline") return /* @__PURE__ */ f(kn, {
		...e,
		entry: i.componentEntry,
		options: i.pluginOptions
	});
	let o = g.get(t, [a[0]]);
	return /* @__PURE__ */ f(tn, {
		...e,
		entry: i.componentEntry,
		rootNode: o,
		options: i.pluginOptions
	});
}
function Mn(e) {
	let { leaf: t } = e, { plugins: n } = q();
	if (!t) return /* @__PURE__ */ f(d, {});
	let r = Object.keys(t).reduce((e, n) => t[n] === !0 ? [...e, n] : e, []), i = "leaf", a = {};
	for (let e of n) if (r.includes(e.name) && H.isLeafPlugin(e)) {
		let t = e.getStyle();
		typeof t == "string" ? i += t ? ` ${t}` : "" : a = {
			...a,
			...t
		};
	}
	return t.text === "" && (a.paddingLeft = "0.1px"), t.spellingError ? /* @__PURE__ */ f(Ln, {
		...e,
		className: i,
		style: a
	}) : t.placeholder ? /* @__PURE__ */ f(In, {
		...e,
		className: i,
		style: a
	}) : t.newline ? /* @__PURE__ */ f(Nn, {
		...e,
		className: i,
		style: a
	}) : t.nonBreakingSpace ? /* @__PURE__ */ f(Pn, {
		...e,
		className: i,
		style: a
	}) : /* @__PURE__ */ f(Fn, {
		...e,
		className: i,
		style: a
	});
}
function Nn(e) {
	let { attributes: t, style: n, className: r } = e;
	return /* @__PURE__ */ f("span", {
		style: n,
		className: `${r} tb-newline`,
		"data-newline": !0,
		...t,
		children: e.children
	});
}
function Pn(e) {
	let { attributes: t, style: n, className: r } = e;
	return /* @__PURE__ */ f("span", {
		style: {
			...n,
			backgroundColor: "color-mix(in srgb, currentColor 24%, transparent)",
			boxShadow: "inset 0 0 0 1px color-mix(in srgb, currentColor 55%, transparent)",
			borderRadius: "2px"
		},
		className: `${r} textbit-nbsp`,
		"data-nbsp": !0,
		...t,
		children: e.children
	});
}
function Fn(e) {
	let { attributes: t, style: n, className: r } = e;
	return /* @__PURE__ */ f("span", {
		style: n,
		className: r,
		...t,
		children: e.children
	});
}
function In(e) {
	let { leaf: t, attributes: n, style: r, className: i } = e, a = l(null), [s, c] = u(void 0);
	return o(() => {
		a.current && c(a.current.offsetWidth);
	}, [t.placeholder]), /* @__PURE__ */ p("div", {
		style: {
			...r,
			width: "100%",
			position: "relative",
			minWidth: s
		},
		className: i,
		...n,
		children: [e.children, t.placeholder && /* @__PURE__ */ f(Rn, {
			ref: a,
			value: t.placeholder,
			style: r
		})]
	});
}
function Ln(e) {
	let { leaf: t, attributes: n, style: r, className: i } = e, a = t.spellingError;
	return /* @__PURE__ */ f("span", {
		style: r,
		className: i,
		"data-spelling-error": a?.id || "",
		"data-spelling-level": a?.level || void 0,
		...n,
		children: e.children
	});
}
function Rn({ value: e, style: t, ref: n }) {
	return /* @__PURE__ */ f("div", {
		ref: n,
		"data-slate-placeholder": !0,
		style: {
			...t,
			opacity: .333,
			position: "absolute",
			top: 0,
			pointerEvents: "none",
			whiteSpace: "nowrap"
		},
		contentEditable: !1,
		children: e
	});
}
function zn(e = !0) {
	let t = D(), n = i(G);
	return s(() => (r) => {
		let i = r.target.nodeType === Node.TEXT_NODE ? r.target.parentElement : r.target;
		if (!i) return;
		let [a, o] = vt(t, i) || [];
		if (!a || !Array.isArray(o)) return;
		let s = t.children[o[0]];
		if (!h.isElement(s)) return;
		let c = Bn(t, s, i, r), l = yt(t, r);
		l && (S.select(t, l), C.focus(t)), e && r.preventDefault(), c && n?.dispatch({
			menu: {
				position: {
					x: r.clientX,
					y: r.clientY
				},
				target: i,
				originalEvent: r,
				nodeEntry: [a, o]
			},
			spelling: c
		});
	}, [
		n,
		e,
		t
	]);
}
function Bn(e, t, n, r) {
	let i = n.closest("[data-spelling-error]")?.dataset.spellingError;
	if (!t.id || !i) return;
	let a = (e.spellingLookupTable.get(t.id)?.errors || []).find((e) => e.id === i);
	try {
		return a ? {
			...a,
			range: yt(e, r),
			apply: (t) => {
				W.replaceStringAtPosition(e, a.text, t);
			}
		} : void 0;
	} catch (e) {
		console.warn(e);
	}
}
function Vn({ children: e }) {
	let t = l(0), [n, r] = u(void 0), [i, a] = u(!1);
	return /* @__PURE__ */ f(nn.Provider, {
		value: {
			dragOver: i,
			offset: n,
			setOffset: r,
			onDragEnter: () => {
				a(!0), t.current++;
			},
			onDragLeave: () => {
				setTimeout(() => {
					--t.current === 0 && a(!1);
				});
			},
			onDrop: () => {
				a(!1);
			}
		},
		children: /* @__PURE__ */ f("div", {
			style: {
				height: "100%",
				position: "relative"
			},
			children: e
		})
	});
}
var Hn = n(null);
function Un({ editor: e, children: t }) {
	let n = T() ?? e, [i, s] = u(() => /* @__PURE__ */ new Map()), c = l(i);
	c.current = i;
	let d = r((e) => {
		let t = crypto.randomUUID();
		return s((n) => {
			let r = new Map(n);
			return r.set(t, {
				pathRef: e.pathRef,
				kind: e.kind
			}), r;
		}), t;
	}, []), p = r((e) => {
		s((t) => {
			let n = t.get(e);
			if (!n) return t;
			n.pathRef.unref();
			let r = new Map(t);
			return r.delete(e), r;
		});
	}, []);
	o(() => (n.pendingDrops = {
		start: d,
		end: p
	}, () => {
		delete n.pendingDrops;
	}), [
		n,
		d,
		p
	]), a(() => () => {
		for (let e of c.current.values()) e.pathRef.unref();
	}, []), a(() => {
		if (!A.isCursorEditor(n)) return;
		let e = n.awareness, t = n.sharedRoot, r = [];
		for (let [e, a] of i) {
			let i = a.pathRef.current;
			if (i) try {
				let o = m.start(n, i), s = N(t, n, o);
				r.push({
					id: e,
					relPos: Array.from(k.encodeRelativePosition(s)),
					kind: a.kind
				});
			} catch {}
		}
		e.setLocalStateField("pendingDrops", r.length ? r : null);
	}, [n, i]), a(() => {
		if (!A.isCursorEditor(n)) return;
		let e = n.awareness;
		return () => {
			e.setLocalStateField("pendingDrops", null);
		};
	}, [n]);
	let [h, g] = u([]);
	a(() => {
		if (!A.isCursorEditor(n)) return;
		let e = n.awareness, t = e.clientID, r = /* @__PURE__ */ new Map(), i = () => {
			let n = [], i = /* @__PURE__ */ new Map(), a = e.getStates();
			for (let [e, r] of a) {
				if (e === t) continue;
				let a = r.pendingDrops;
				if (Array.isArray(a)) {
					i.set(e, JSON.stringify(a));
					for (let t of a) !t || typeof t.id != "string" || !Array.isArray(t.relPos) || n.push({
						peerId: e,
						raw: t,
						peerData: r.data
					});
				}
			}
			r.clear();
			for (let [e, t] of i) r.set(e, t);
			g(n);
		}, a = ({ added: n, updated: a, removed: o }) => {
			let s = o.some((e) => r.has(e));
			if (!s) {
				let i = e.getStates();
				for (let e of n.concat(a)) {
					if (e === t) continue;
					let n = i.get(e)?.pendingDrops;
					if ((Array.isArray(n) ? JSON.stringify(n) : "") !== (r.get(e) ?? "")) {
						s = !0;
						break;
					}
				}
			}
			s && i();
		};
		return i(), e.on("change", a), () => {
			e.off("change", a);
		};
	}, [n]);
	let _ = l(/* @__PURE__ */ new Map()), v = r((e) => {
		let t = e.join(","), n = _.current.get(t);
		return n || (n = k.decodeRelativePosition(Uint8Array.from(e)), _.current.set(t, n)), n;
	}, []), y = [];
	for (let [e, t] of i) {
		let n = t.pathRef.current;
		n && y.push({
			id: e,
			source: "own",
			path: n,
			kind: t.kind
		});
	}
	if (A.isCursorEditor(n) && h.length) {
		let e = n.sharedRoot;
		for (let { peerId: t, raw: r, peerData: i } of h) try {
			let a = v(r.relPos), o = M(e, n, a);
			if (!o) continue;
			y.push({
				id: `${t}:${r.id}`,
				source: "peer",
				path: o.path.slice(0, 1),
				kind: r.kind,
				peerId: t,
				peerData: i
			});
		} catch {}
	}
	let b = {
		drops: y,
		start: d,
		end: p
	};
	return /* @__PURE__ */ f(Hn.Provider, {
		value: b,
		children: t
	});
}
function Wn({ children: e }) {
	let t = l(null), [n] = oe({ containerRef: t });
	return /* @__PURE__ */ p("div", {
		style: {
			height: "100%",
			position: "relative"
		},
		className: "textbit-y-overlay",
		ref: t,
		children: [e, n.map((e) => /* @__PURE__ */ f(Gn, { ...e }, e.clientId))]
	});
}
function Gn({ data: e, selectionRects: t, caretPosition: n }) {
	if (!e) return null;
	let r = {
		position: "absolute",
		pointerEvents: "none",
		backgroundColor: e?.color || "gray",
		opacity: .5
	};
	return /* @__PURE__ */ p(d, { children: [t.map((e, t) => /* @__PURE__ */ f("div", {
		className: "textbit-y-selection",
		style: {
			...r,
			...e
		}
	}, t)), n && /* @__PURE__ */ f(Kn, {
		caretPosition: n,
		data: e
	})] });
}
function Kn({ caretPosition: e, data: t }) {
	let n = l(null), [r, i] = u(!0);
	a(() => {
		if (!n.current) return;
		let e = n.current.closest(".textbit-y-overlay");
		if (!e) return;
		let t = n.current.getBoundingClientRect(), r = e.getBoundingClientRect();
		i(t.top - r.top > t.height);
	}, [e]);
	let o = s(() => ({
		position: "absolute",
		...e,
		background: t?.color || "gray",
		width: "2px"
	}), [e, t?.color]), c = s(() => ({
		backgroundColor: t?.color?.trim() || "gray",
		position: "absolute",
		fontFamily: "sans-serif",
		fontSize: "80%",
		borderRadius: "2px",
		transform: r ? "translateY(-91%)" : `translateY(${e?.height || 44}px)`,
		width: "max-content",
		padding: "0px 6px 1px 6px",
		opacity: .9,
		whiteSpace: "nowrap",
		top: 0,
		borderBottomLeftRadius: 0
	}), [
		t?.color,
		r,
		e?.height
	]);
	return /* @__PURE__ */ f("div", {
		ref: n,
		style: o,
		className: "textbit-y-caret",
		children: /* @__PURE__ */ f("div", {
			style: c,
			children: t?.name || "?"
		})
	});
}
function qn({ children: e, isCollaborative: t }) {
	let { readOnly: n } = J();
	return /* @__PURE__ */ f(d, { children: f(!t || n ? d : Wn, { children: e }) });
}
function Jn() {
	let e = jr(), t = l(null);
	return a(() => {
		t.current && (t.current.style.top = `${e?.y}px`, t.current.style.left = `${e?.x}px`, t.current.style.width = `${e?.width}px`, t.current.style.height = `${e?.height}px`);
	}, [e]), /* @__PURE__ */ f("div", {
		ref: t,
		style: {
			position: "absolute",
			top: 0,
			left: 0,
			outline: "1px solid rgba(191, 191, 99, 0.5",
			outlineOffset: "4px"
		},
		children: e && /* @__PURE__ */ p("div", {
			style: {
				position: "absolute",
				top: "calc(100% + 1px)",
				left: "calc(80% + 4px)",
				pointerEvents: "none",
				background: "rgb(255, 255, 255)",
				borderRadius: "2px",
				padding: "4px 6px",
				color: "rgba(225, 99, 99, 0.8)",
				fontSize: "11px",
				whiteSpace: "nowrap",
				fontFamily: "monospace",
				fontWeight: "bold",
				border: "1px solid rgba(255, 99, 99, 0.8)",
				display: "grid",
				gridTemplateColumns: "1fr 1fr",
				gridTemplateRows: "1fr 1fr",
				gridGap: "6px 10px"
			},
			children: [
				/* @__PURE__ */ p("div", { children: ["x:", Math.round(e.x)] }),
				/* @__PURE__ */ p("div", { children: ["y:", Math.round(e.y)] }),
				/* @__PURE__ */ p("div", { children: ["w:", Math.round(e.width)] }),
				/* @__PURE__ */ p("div", { children: ["h:", Math.round(e.height)] })
			]
		})
	});
}
function Yn({ value: e, children: t }) {
	return /* @__PURE__ */ f(wn.Provider, {
		value: e,
		children: t
	});
}
function Xn({ value: e, children: t }) {
	return /* @__PURE__ */ f(En.Provider, {
		value: e,
		children: t
	});
}
var Zn = (e, t) => {
	let n = W.selectedTextEntries(e);
	if (!n.length) return !1;
	for (let [e] of n) if (!x.isText(e) || !Object.keys(e).includes(t) || e[t] !== !0) return !1;
	return !0;
}, Qn = (e, t) => {
	Zn(e, t) ? m.removeMark(e, t) : m.addMark(e, t, !0);
};
function $n(e, t) {
	return t.children.findIndex((t) => !h.isElement(t) || !e.isVoid(t));
}
function er(e, t) {
	return t.children.reduce((t, n, r) => !h.isElement(n) || !e.isVoid(n) ? r : t, -1);
}
function tr(e, t, n) {
	let r = e.children[n];
	if (!h.isElement(r)) return !1;
	let i = $n(e, r);
	return i < 0 ? m.isStart(e, t, [n]) : m.isStart(e, t, [n, i]);
}
function nr(e, t, n) {
	let r = e.children[n];
	if (!h.isElement(r)) return !1;
	let i = er(e, r);
	return i < 0 ? m.isEnd(e, t, [n]) : m.isEnd(e, t, [n, i]);
}
function Y(e, t) {
	return e.children.findIndex((e) => h.isElement(e) && e.id === t.blockId);
}
function rr(e, t) {
	t < e.children.length ? S.select(e, m.start(e, [t])) : e.children.length > 0 && S.select(e, m.end(e, [e.children.length - 1]));
}
function X(e, t, n) {
	let r = t, i = $n(e, n);
	i >= 0 && (r = [...t, i]), S.select(e, m.start(e, r));
}
function Z(e, t, n) {
	let r = t, i = er(e, n);
	i >= 0 && (r = [...t, i]), S.select(e, m.end(e, r));
}
function ir(e, t, n, r, i, a) {
	let o = Y(e, n);
	if (o === -1) {
		r(null);
		return;
	}
	let s = [o], c = e.children[o], l = h.isElement(c) && e.isVoid(c), { direction: u } = n;
	if (i && u === "before") {
		t.preventDefault(), l ? r({
			blockId: n.blockId,
			direction: "after"
		}) : (X(e, s, c), r(null));
		return;
	}
	if (i && u === "after") {
		t.preventDefault();
		let n = o + 1;
		if (n < e.children.length) {
			let t = e.children[n];
			S.select(e, m.start(e, [n])), h.isElement(t) && t.class !== "text" ? r({
				blockId: t.id,
				direction: "before"
			}) : r(null);
		} else r(null);
		return;
	}
	if (a && u === "after") {
		t.preventDefault(), l ? r({
			blockId: n.blockId,
			direction: "before"
		}) : (Z(e, s, c), r(null));
		return;
	}
	if (a && u === "before") {
		t.preventDefault();
		let n = o - 1;
		if (n >= 0) {
			let t = e.children[n];
			S.select(e, m.end(e, [n])), h.isElement(t) && t.class !== "text" ? r({
				blockId: t.id,
				direction: "after"
			}) : r(null);
		} else r(null);
		return;
	}
	r(null);
}
function ar(e, t, n, r) {
	let i = Y(e, n);
	if (i === -1) {
		t.preventDefault();
		return;
	}
	let a = t.key === "ArrowUp", o = a ? i - 1 : i + 1;
	if (o < 0 || o >= e.children.length) {
		t.preventDefault();
		return;
	}
	let s = e.children[o];
	if (h.isElement(s) && s.class !== "text") {
		t.preventDefault(), n.direction === "after" ? Z(e, [o], s) : X(e, [o], s), r({
			blockId: s.id,
			direction: n.direction
		});
		return;
	}
	let c = e.children[i], l = h.isElement(c) && e.isVoid(c);
	if (n.direction === "after" && a || n.direction === "before" && !a || l) {
		t.preventDefault(), S.select(e, a ? m.end(e, [o]) : m.start(e, [o])), r(null);
		return;
	}
	r(null);
}
function or(e, t, n, r, i, a, o) {
	let s = [a], c = e.children[a];
	if (r) {
		if (h.isElement(c) && c.class !== "text" && nr(e, o, a)) return t.preventDefault(), n({
			blockId: c.id,
			direction: "after"
		}), !0;
		if (m.isEnd(e, o, s)) {
			let r = a + 1;
			if (r < e.children.length) {
				let i = e.children[r];
				if (h.isElement(i) && i.class !== "text") return t.preventDefault(), X(e, [r], i), n({
					blockId: i.id,
					direction: "before"
				}), !0;
			}
		}
	}
	if (i) {
		if (h.isElement(c) && c.class !== "text" && tr(e, o, a)) return t.preventDefault(), n({
			blockId: c.id,
			direction: "before"
		}), !0;
		if (m.isStart(e, o, s)) {
			let r = a - 1;
			if (r >= 0) {
				let i = e.children[r];
				if (h.isElement(i) && i.class !== "text") return t.preventDefault(), S.select(e, m.end(e, [r])), n({
					blockId: i.id,
					direction: "after"
				}), !0;
			}
		}
	}
	return !1;
}
function sr(e, t, n, r) {
	if (t.key === "Enter") {
		let i = Y(e, n);
		if (i !== -1) {
			t.preventDefault();
			let a = n.direction === "before" ? i : i + 1, o = {
				id: crypto.randomUUID(),
				class: "text",
				type: "core/text",
				children: [{ text: "" }]
			};
			return S.insertNodes(e, o, { at: [a] }), S.select(e, m.start(e, [a])), r(null), !0;
		}
	}
	let { selection: i } = e;
	if (i && b.isCollapsed(i)) {
		if (t.key === "Backspace" && n.direction === "after") {
			let i = Y(e, n);
			if (i !== -1) {
				t.preventDefault(), S.removeNodes(e, { at: [i] });
				let n = i - 1;
				return n >= 0 && n < e.children.length ? S.select(e, m.end(e, [n])) : e.children.length > 0 && S.select(e, m.start(e, [0])), r(null), !0;
			}
		}
		if (t.key === "Backspace" && n.direction === "before") {
			let i = Y(e, n);
			if (i !== -1) {
				let n = i - 1, a = n >= 0 ? e.children[n] : null;
				if (a && h.isElement(a)) {
					if (t.preventDefault(), a.class !== "text") {
						S.removeNodes(e, { at: [n] });
						let t = e.children[n];
						return h.isElement(t) && t.class !== "text" ? (X(e, [n], t), r({
							blockId: t.id,
							direction: "before"
						})) : (rr(e, n), r(null)), !0;
					}
					return g.string(a) === "" ? (S.removeNodes(e, { at: [n] }), rr(e, n)) : (S.select(e, m.end(e, [n])), S.delete(e, {
						unit: "character",
						reverse: !0
					})), r(null), !0;
				}
			}
		}
		if (t.key === "Delete" && n.direction === "before") {
			let i = Y(e, n);
			if (i !== -1) {
				if (t.preventDefault(), S.removeNodes(e, { at: [i] }), i < e.children.length) {
					let t = e.children[i];
					h.isElement(t) && t.class !== "text" ? (X(e, [i], t), r({
						blockId: t.id,
						direction: "before"
					})) : (S.select(e, m.start(e, [i])), r(null));
				} else if (e.children.length > 0) {
					let t = e.children.length - 1, n = e.children[t];
					h.isElement(n) && n.class !== "text" ? (Z(e, [t], n), r({
						blockId: n.id,
						direction: "after"
					})) : (S.select(e, m.end(e, [t])), r(null));
				} else r(null);
				return !0;
			}
		}
	}
	if ([
		"Meta",
		"Control",
		"Alt",
		"Shift",
		"CapsLock"
	].includes(t.key) || (t.metaKey || t.ctrlKey) && t.key === "v") return !0;
	if (t.key.length === 1 && !t.ctrlKey && !t.metaKey && !t.altKey) {
		let t = Y(e, n);
		if (t !== -1) {
			let i = n.direction === "before" ? t : t + 1, a = {
				id: crypto.randomUUID(),
				class: "text",
				type: "core/text",
				children: [{ text: "" }]
			};
			return S.insertNodes(e, a, { at: [i] }), S.select(e, m.start(e, [i])), r(null), !0;
		}
	}
	return r(null), !1;
}
function cr(e, t) {
	let n = Math.min(t.anchorIndex, t.focusIndex), r = Math.max(t.anchorIndex, t.focusIndex);
	S.select(e, {
		anchor: m.start(e, [n]),
		focus: m.end(e, [r])
	});
}
function lr(e, t, n) {
	let r = Math.min(t.anchorIndex, t.focusIndex), i = Math.max(t.anchorIndex, t.focusIndex);
	m.withoutNormalizing(e, () => {
		for (let t = i; t >= r; t--) S.removeNodes(e, { at: [t] });
	}), n(null), r < e.children.length ? S.select(e, m.start(e, [r])) : e.children.length > 0 && S.select(e, m.end(e, [e.children.length - 1]));
}
function ur(e, t, n) {
	let r = Y(e, n);
	if (r === -1) return null;
	let i = t.key === "ArrowDown" || t.key === "ArrowRight", { direction: a } = n, o;
	if (o = a === "before" && !i ? r - 1 : a === "before" && i || a === "after" && !i ? r : r + 1, o < 0 || o >= e.children.length) return null;
	let s = {
		anchorIndex: o,
		focusIndex: o
	};
	return cr(e, s), s;
}
function dr(e, t, n, r, i) {
	let a = t.key, o = a === "ArrowUp" || a === "ArrowDown" || a === "ArrowLeft" || a === "ArrowRight", s = t.metaKey || t.ctrlKey;
	if (t.shiftKey && o) {
		t.preventDefault();
		let i = a === "ArrowDown" || a === "ArrowRight", o = e.children.length - 1, s = i ? Math.min(n.focusIndex + 1, o) : Math.max(n.focusIndex - 1, 0), c = {
			...n,
			focusIndex: s
		};
		r(c), cr(e, c);
		return;
	}
	if (o && !t.shiftKey) {
		t.preventDefault();
		let o = Math.min(n.anchorIndex, n.focusIndex), s = Math.max(n.anchorIndex, n.focusIndex), c = a === "ArrowUp" || a === "ArrowLeft", l = c ? o : s, u = e.children[l];
		r(null), h.isElement(u) && u.class !== "text" ? c ? (X(e, [l], u), i({
			blockId: u.id,
			direction: "before"
		})) : (Z(e, [l], u), i({
			blockId: u.id,
			direction: "after"
		})) : c ? S.select(e, m.start(e, [l])) : S.select(e, m.end(e, [l]));
		return;
	}
	if (a === "Backspace" || a === "Delete") {
		t.preventDefault(), lr(e, n, r);
		return;
	}
	if (!(s && a === "c")) {
		if (s && a === "x") {
			document.execCommand("copy"), t.preventDefault(), lr(e, n, r);
			return;
		}
		s && a === "v" || t.preventDefault();
	}
}
function fr(e, t, n, r, i, a, o) {
	if (a) {
		dr(e, n, a, o, i);
		return;
	}
	if (r && n.shiftKey && (n.key === "ArrowUp" || n.key === "ArrowDown" || n.key === "ArrowLeft" || n.key === "ArrowRight")) {
		let t = ur(e, n, r);
		t && (n.preventDefault(), i(null), o(t));
		return;
	}
	let s = n.key, c = s === "ArrowRight", l = s === "ArrowLeft";
	if (c || l) {
		let { selection: t } = e;
		if (!t || !b.isCollapsed(t)) {
			r && i(null);
			return;
		}
		let { anchor: a } = t, o = a.path[0];
		if (r) {
			ir(e, n, r, i, c, l);
			return;
		}
		if (or(e, n, i, c, l, o, a)) return;
	} else if (s === "ArrowUp" || s === "ArrowDown") {
		if (r) {
			ar(e, n, r, i);
			return;
		}
		let { selection: t } = e;
		if (t && b.isCollapsed(t)) {
			let { anchor: r } = t, i = r.path[0], a = e.children[i];
			if (h.isElement(a) && a.class !== "text") {
				if (s === "ArrowDown" && i === e.children.length - 1 && nr(e, r, i)) {
					n.preventDefault();
					return;
				}
				if (s === "ArrowUp" && i === 0 && tr(e, r, i)) {
					n.preventDefault();
					return;
				}
			}
		}
	} else if (r && sr(e, n, r, i)) return;
	for (let r of t) if (r.isHotkey(n)) {
		if (r.handler && !r.handler({
			editor: e,
			event: n,
			type: r.plugin.name,
			options: { ...r.plugin.options }
		})) break;
		r.plugin.class === "leaf" ? (n.preventDefault(), Qn(e, r.plugin.name)) : r.plugin.class === "text" && (n.preventDefault(), S.setNodes(e, { type: r.plugin.name }, { match: (t) => h.isElement(t) && m.isBlock(e, t) }));
		break;
	}
}
var pr = ({ editor: e }) => {
	let t = [];
	for (let [n, r] of m.nodes(e, {
		at: [],
		match: (e) => h.isElement(e)
	})) {
		if (r.length !== 1) continue;
		let [e, i] = g.first(n, []);
		if (x.isText(e)) {
			let n = e.text.match(/^[\t\n\r\f\v ]+/);
			if (n) {
				let e = [...r, ...i];
				t.push({
					anchor: {
						path: e,
						offset: 0
					},
					focus: {
						path: e,
						offset: n[0].length
					}
				});
			}
		}
		let [a, o] = g.last(n, []);
		if (x.isText(a)) {
			let e = a.text.match(/[\t\n\r\f\v ]+$/);
			if (e) {
				let n = [...r, ...o], i = a.text.length;
				t.push({
					anchor: {
						path: n,
						offset: i - e[0].length
					},
					focus: {
						path: n,
						offset: i
					}
				});
			}
		}
	}
	for (let n of t.reverse()) S.delete(e, { at: n });
};
function mr(e, t, n, r) {
	if (!n && !r) return "unhandled";
	let i = hr(e, n, r);
	if (i === null) return "unhandled";
	let { targetIndex: a, removeRange: o } = i, s = gr(t);
	if (s && s.length > 0) {
		m.withoutNormalizing(e, () => {
			if (o) for (let t = o.hi; t >= o.lo; t--) S.removeNodes(e, { at: [t] });
			S.insertNodes(e, s, { at: [a] });
		});
		let t = [a + s.length - 1];
		try {
			S.select(e, m.end(e, t));
		} catch {}
		return "handled";
	}
	return m.withoutNormalizing(e, () => {
		if (o) for (let t = o.hi; t >= o.lo; t--) S.removeNodes(e, { at: [t] });
		let t = {
			id: crypto.randomUUID(),
			type: "core/text",
			class: "text",
			properties: {},
			children: [{ text: "" }]
		};
		S.insertNodes(e, t, {
			at: [a],
			select: !0
		});
	}), "prepared";
}
function hr(e, t, n) {
	if (n) {
		let t = Math.min(n.anchorIndex, n.focusIndex), r = Math.max(n.anchorIndex, n.focusIndex);
		return t < 0 || r >= e.children.length ? null : {
			targetIndex: t,
			removeRange: {
				lo: t,
				hi: r
			}
		};
	}
	if (t) {
		let n = e.children.findIndex((e) => h.isElement(e) && e.id === t.blockId);
		return n === -1 ? null : {
			targetIndex: t.direction === "before" ? n : n + 1,
			removeRange: null
		};
	}
	return null;
}
function gr(e) {
	if (!e.types.includes("application/x-slate-fragment")) return null;
	let t = e.getData("application/x-slate-fragment");
	if (!t) return null;
	try {
		let e = decodeURIComponent(window.atob(t)), n = JSON.parse(e);
		return Array.isArray(n) ? n : null;
	} catch {
		return null;
	}
}
function _r(e) {
	let t = D(), { placeholders: n, placeholder: i, readOnly: o, dir: s, collaborative: c, verbose: _ } = J(), { components: v, actions: y } = q(), x = w(), ee = zn(), [ne, re] = u(/* @__PURE__ */ new Map()), [T, E] = u(null), [O, k] = u(null), { onFocus: A, onBlur: j, constraints: M, autoFocus: N = !1 } = e;
	a(() => {
		t.allowEdgeWhitespace = M?.allowEdgeWhitespace !== !1;
	}, [t, M?.allowEdgeWhitespace]);
	let P = l(!0);
	a(() => (P.current = !0, () => {
		P.current = !1;
	}), []);
	let F = l(!1), ae = r((e) => {
		let n = F.current;
		F.current = !1, queueMicrotask(() => {
			n || t.selection || S.select(t, N === "end" ? m.end(t, []) : m.start(t, []));
		}), A?.(e);
	}, [
		t,
		N,
		A
	]);
	a(() => {
		typeof t.onSpellcheckComplete == "function" && t.onSpellcheckComplete((e) => {
			P.current && re(e);
		});
	}, [t]);
	let oe = r((e) => jn({ ...e }), []), I = r((e) => Mn(e), []), L = ie((e) => e.children.every((e) => g.string(e) === "")), se = r((e) => en(t, ne, e, v, n, i, L), [
		t,
		v,
		n,
		i,
		ne,
		L
	]), ce = r((e) => {
		if (M?.allowEdgeWhitespace !== !1) {
			j?.(e);
			return;
		}
		queueMicrotask(() => {
			pr({ editor: t });
		}), j?.(e);
	}, [
		t,
		M,
		j
	]), R = r((e) => {
		fr(t, y, e, T, E, O, k);
	}, [
		t,
		y,
		T,
		E,
		O,
		k
	]), z = r((e) => {
		if (!T && !O) return;
		let n = e.clipboardData;
		if (!n) return;
		let r = mr(t, n, T, O);
		r !== "unhandled" && (T && E(null), O && k(null), r === "handled" && e.preventDefault());
	}, [
		t,
		T,
		O,
		E,
		k
	]), B = r((e) => {
		F.current = !0;
		let n = e.clientX, r = e.clientY;
		for (let i = 0; i < t.children.length; i++) {
			let a = t.children[i];
			if (!h.isElement(a) || a.class === "text") continue;
			let o;
			try {
				o = C.toDOMNode(t, a);
			} catch {
				continue;
			}
			let s = o.getBoundingClientRect();
			if (r < s.top || r > s.bottom || n >= s.left && n <= s.right) continue;
			e.preventDefault(), C.focus(t);
			let c = n < (s.left + s.right) / 2 ? "before" : "after";
			c === "before" ? S.select(t, m.start(t, [i])) : S.select(t, m.end(t, [i])), E({
				blockId: a.id,
				direction: c
			}), O && k(null);
			return;
		}
		if (T && E(null), O && k(null), navigator.userAgent.includes("Gecko/") && !x) {
			let n = C.findEventRange(t, e);
			b.isRange(n) && S.select(t, n);
		}
	}, [
		t,
		x,
		T,
		E,
		O,
		k
	]);
	return /* @__PURE__ */ p(d, { children: [/* @__PURE__ */ f(Xn, {
		value: O,
		children: /* @__PURE__ */ f(Yn, {
			value: T,
			children: /* @__PURE__ */ f(Vn, { children: /* @__PURE__ */ f(qn, {
				isCollaborative: c,
				children: /* @__PURE__ */ p(Un, {
					editor: t,
					children: [/* @__PURE__ */ f(te, {
						autoFocus: !!N,
						"data-state": x ? "focused" : "",
						readOnly: o,
						renderElement: oe,
						renderLeaf: I,
						onFocus: ae,
						onBlur: ce,
						onKeyDown: R,
						onPaste: z,
						decorate: se,
						className: e.className,
						style: T || O ? {
							...e.style,
							caretColor: "transparent"
						} : e.style,
						spellCheck: !1,
						dir: s,
						onContextMenu: ee,
						onMouseDown: B,
						"aria-label": e["aria-label"]
					}), e.children]
				})
			}) })
		})
	}), _ && /* @__PURE__ */ f(Jn, {})] });
}
function vr({ children: e, style: t, className: n }) {
	return /* @__PURE__ */ f("div", {
		style: t,
		className: n,
		children: e
	});
}
var yr = {
	Provider: Yt,
	Content: vr
};
function br({ className: e, style: t = {} }) {
	let n = l(null), { offset: r, dragOver: a } = i(nn), [s, c] = u(null);
	o(() => {
		if (!n.current || !a) return;
		let e = n.current.parentElement;
		if (!e) return;
		let t = xr(e);
		t && c(t.getBoundingClientRect());
	}, [a, r]);
	let d = {
		height: "3px",
		backgroundColor: "rgb(191, 191, 191)",
		borderRadius: "2px"
	}, p = { display: "none" };
	if (a && r && s) {
		let { bbox: e, position: t } = r;
		if (!e) return null;
		let n = e.left - s.left, i = e.top - s.top;
		p.display = "block", p.left = n, p.width = e.width, t?.[1] ? (p.top = i, p.height = e.height + 2, p.backgroundColor = "rgba(191, 191, 191, 0.4)", p.borderRadius = "4px") : p.top = t?.[0] === "above" ? i - 2 : i + e.height - 2;
	}
	let m = a ? r?.position?.[1] ? "around" : "between" : "none";
	return /* @__PURE__ */ f("div", {
		ref: n,
		className: e,
		"data-dragover": m,
		style: {
			pointerEvents: "none",
			position: "absolute",
			margin: 0,
			userSelect: "none",
			...d,
			...p,
			...t
		}
	});
}
function xr(e) {
	let t = e;
	for (; t;) {
		if (getComputedStyle(t).position !== "static") return t;
		t = t.parentElement;
	}
	return null;
}
function Sr() {
	return i(Hn)?.drops ?? [];
}
var Cr = 60;
function wr({ className: e, style: t, height: n = Cr, children: r }) {
	let i = D(), s = Sr(), c = l(null), [d, m] = u(null);
	o(() => {
		if (s.length === 0) return;
		let e = [];
		for (let t of s) {
			let r = kr(i, t.path);
			if (!r) continue;
			let a = r.style.marginTop;
			r.style.marginTop = `${n}px`, e.push(() => {
				r.style.marginTop = a;
			});
		}
		return () => {
			for (let t of e) t();
		};
	}, [
		s,
		i,
		n
	]), o(() => {
		if (!c.current) return;
		let e = c.current.parentElement;
		if (!e) return;
		let t = Or(e);
		if (!t) return;
		let n = () => m(t.getBoundingClientRect());
		if (n(), s.length === 0) return;
		let r = new ResizeObserver(n);
		r.observe(t);
		let a = Array.from(e.children).find((e) => e.getAttribute("role") === "textbox");
		a && r.observe(a);
		for (let e of s) {
			let t = kr(i, e.path);
			t && r.observe(t);
		}
		return window.addEventListener("scroll", n, {
			passive: !0,
			capture: !0
		}), window.addEventListener("resize", n, { passive: !0 }), () => {
			r.disconnect(), window.removeEventListener("scroll", n, { capture: !0 }), window.removeEventListener("resize", n);
		};
	}, [s, i]);
	let h = s.filter((e) => e.source === "own").length, [g, _] = u("");
	return a(() => {
		if (h === 0) {
			_("");
			return;
		}
		_(h === 1 ? "Upload in progress" : `${h} uploads in progress`);
	}, [h]), s.length === 0 || !d ? /* @__PURE__ */ f("div", {
		ref: c,
		style: { display: "none" },
		children: /* @__PURE__ */ f(Tr, { text: g })
	}) : /* @__PURE__ */ p("div", {
		ref: c,
		style: { display: "contents" },
		children: [/* @__PURE__ */ f(Tr, { text: g }), s.map((a) => {
			let o = Ar(i, a.path);
			if (!o) return null;
			let s = {
				position: "absolute",
				left: o.left - d.left,
				top: o.top - d.top - n,
				width: o.width,
				height: n,
				pointerEvents: "none",
				userSelect: "none"
			};
			return /* @__PURE__ */ f("div", {
				className: e,
				"data-source": a.source,
				"data-kind": a.kind ?? "",
				style: {
					...Dr,
					...s,
					...t
				},
				children: r ? r(a) : null
			}, a.id);
		})]
	});
}
function Tr({ text: e }) {
	return /* @__PURE__ */ f("div", {
		role: "status",
		"aria-live": "polite",
		"aria-atomic": "true",
		style: Er,
		children: e
	});
}
var Er = {
	position: "absolute",
	width: 1,
	height: 1,
	padding: 0,
	margin: -1,
	overflow: "hidden",
	clip: "rect(0, 0, 0, 0)",
	whiteSpace: "nowrap",
	border: 0
}, Dr = {
	background: "rgba(191, 191, 191, 0.25)",
	border: "1px dashed rgba(128, 128, 128, 0.6)",
	borderRadius: 2
};
function Or(e) {
	let t = e;
	for (; t;) {
		if (getComputedStyle(t).position !== "static") return t;
		t = t.parentElement;
	}
	return null;
}
function kr(e, t) {
	try {
		let [n] = e.node(t);
		return C.toDOMNode(e, n);
	} catch {
		return null;
	}
}
function Ar(e, t) {
	let n = kr(e, t);
	return n ? n.getBoundingClientRect() : null;
}
var jr = () => {
	let e = i(Re);
	if (!e) throw Error("useTextbitSelectionBoundsState must be used within a TextbitSelectionBoundsProvider");
	let [t, n] = u(e.boundsRef.current);
	return a(() => e.subscribe(n), [e]), t;
};
function Mr({ children: e, className: t }) {
	return I(/* @__PURE__ */ f(Nr, {
		className: t,
		children: e
	}), document.body);
}
function Nr({ children: e, className: t }) {
	let n = D(), o = jr(), s = w(), c = Dn(), u = l(null), d = i(G)?.menu != null, p = r((e) => {
		let t = u.current;
		t && (t.style.opacity = e ? "1" : "0", t.style.pointerEvents = e ? "auto" : "none");
	}, []);
	a(() => {
		if (!s) return;
		let e = !1;
		o?.isCollapsed ? n.selection && (e = !!m.nodes(n, {
			at: n.selection,
			match: (e) => U.isElement(e) && e.class === "inline"
		}).next().value) : e = !0, p(!!(e && !d && !c));
	}, [
		n,
		o,
		s,
		p,
		d,
		c
	]);
	let h = r((e) => {
		if (!s) return;
		let t = u.current;
		if (!t || !e || e.left <= 0 || e.top <= 0) return;
		let n = t.getBoundingClientRect(), r = e.left + e.width / 2 - n.width / 2, i = e.top - n.height - 8, a = window.innerWidth - n.width - 8;
		r = Math.max(8, Math.min(r, a)), i < 8 && (i = e.top + e.height + 8);
		let o = window.innerHeight - n.height - 8;
		i > o && (i = e.top - n.height - 8, i = Math.min(i, o)), t.style.transform = `translate(${r}px, ${i}px)`;
	}, [s]);
	return a(() => {
		o ? requestAnimationFrame(() => h(o)) : p(!1);
	}, [
		h,
		o,
		p
	]), a(() => {
		let e = u.current;
		if (!e) return;
		let t = new ResizeObserver(() => {
			o && requestAnimationFrame(() => h(o));
		});
		return t.observe(e), () => {
			t.disconnect();
		};
	}, [h, o]), /* @__PURE__ */ f("div", {
		ref: u,
		className: t,
		style: {
			position: "fixed",
			top: 0,
			left: 0,
			opacity: 0,
			pointerEvents: "none",
			willChange: "transform",
			zIndex: 9701
		},
		children: e
	});
}
function Pr({ children: n, className: i }) {
	let a = D(), o = E(), s = m.nodes(a, { mode: "lowest" }).next().value || void 0, c = r((n) => !s || !o ? n : t.toArray(n).filter((t) => b.isCollapsed(o) ? e.isValidElement(t) ? t.props?.action?.plugin?.class === "inline" : !1 : !0), [s, o])(n), l = t.count(c) > 0;
	return /* @__PURE__ */ f(d, { children: l ? /* @__PURE__ */ f("div", {
		className: i || "",
		children: n
	}) : /* @__PURE__ */ f(d, {}) });
}
function Fr({ action: e, className: n, children: r }) {
	let i = D(), a = E(), o = Zn(i, e.plugin.name), s = m.nodes(i, { mode: "lowest" }).next().value || void 0, c = Array.from(m.nodes(i, {
		match: (t) => U.isElement(t) && t.class === "inline" && t.type === e.plugin.name,
		at: a ?? void 0
	})), l = Array.isArray(e.tool) ? e.tool.length === 2 && c.length === 1 ? e.tool[1] : e.tool[0] : e.tool;
	if (l) {
		if (c.length === 1) {
			let e = c[0];
			return /* @__PURE__ */ p("div", {
				"data-state": "active",
				children: [t.count(r) ? /* @__PURE__ */ f(l, {
					editor: i,
					active: o,
					entry: e,
					children: r
				}) : /* @__PURE__ */ f(l, {
					editor: i,
					active: o,
					entry: e
				}), /* @__PURE__ */ f("em", { className: "active" })]
			});
		}
		return /* @__PURE__ */ f("div", {
			"data-state": o ? "active" : "inactive",
			className: n || "",
			onMouseDown: (t) => {
				c.length > 1 || (e.handler({
					editor: i,
					event: t,
					type: e.plugin.name,
					options: { ...e.plugin.options }
				}) && Qn(i, e.plugin.name), t.defaultPrevented || t.preventDefault());
			},
			children: /* @__PURE__ */ f(l, {
				editor: i,
				active: o,
				entry: s,
				children: r
			})
		});
	}
}
var Ir = {
	Menu: Mr,
	Group: Pr,
	Item: Fr
}, Lr = n([!1, () => {}]);
function Rr({ children: e, className: t, style: n = {} }) {
	let [r, i] = u(!1), s = l(null), c = jr(), d = w(), { readOnly: p } = J();
	return o(() => {
		let e = s.current;
		if (!e || !c || p || !d) return;
		let t = e.offsetParent;
		if (!t) return;
		let n = t.getBoundingClientRect(), r = (c.box?.top ?? c.top) - n.top;
		e.style.top = `${r}px`;
	}, [
		c,
		p,
		d
	]), a(() => {
		i((e) => d ? e : !1);
	}, [d]), p || !d || !c ? null : /* @__PURE__ */ f(Lr.Provider, {
		value: [r, i],
		children: /* @__PURE__ */ f("div", {
			ref: s,
			className: t,
			"data-state": r ? "open" : "closed",
			style: {
				position: "absolute",
				top: 0,
				zIndex: 9909,
				...n
			},
			children: e
		})
	});
}
function zr(e) {
	let t = l(null), n = l(e);
	return o(() => {
		n.current = e;
	}), a(() => {
		let e = (e) => {
			(t?.current)?.contains(e.target) || n.current(e);
		};
		return document.addEventListener("mousedown", e), document.addEventListener("touchstart", e), () => {
			document.removeEventListener("mousedown", e), document.removeEventListener("touchstart", e);
		};
	}, []), t;
}
function Br({ children: e, className: t }) {
	let [n, r] = i(Lr), { triggerRef: o, updateTriggerRef: s } = i(Jt), c = zr(() => {
		r(!1);
	});
	return a(() => {
		o && c.current && s(c.current);
	}, [
		o,
		s,
		c
	]), /* @__PURE__ */ f("a", {
		ref: c,
		className: t,
		onMouseDown: (e) => {
			e.preventDefault(), r(!n);
		},
		children: e
	});
}
function Vr(e) {
	let t = l(null), n = l(e);
	return o(() => {
		n.current = e;
	}), a(() => {
		let e = (e) => {
			(t?.current)?.contains(e.target) || n.current(e);
		};
		return document.addEventListener("keydown", e, { capture: !0 }), () => {
			document.removeEventListener("keydown", e, { capture: !0 });
		};
	}, []), t;
}
function Hr({ children: e, className: t }) {
	let [n, r] = i(Lr), a = Vr((e) => {
		n && (e.key === "Escape" || e.key === "Tab") && (e.preventDefault(), r(!1));
	});
	return /* @__PURE__ */ f("div", {
		ref: a,
		children: n && /* @__PURE__ */ f(Ur, {
			className: t,
			children: e
		})
	});
}
function Ur({ children: e, className: t }) {
	let { triggerRef: n } = i(Jt), r = l(null);
	return o(() => {
		let e = r.current, t = n?.current;
		if (!t || !e) return;
		let i = t.getBoundingClientRect(), a = e.getBoundingClientRect(), o = i.right + 8, s = i.top, c = window.innerWidth - a.width - 8;
		o = Math.min(o, c), s + a.height > window.innerHeight - 8 && (s = Math.max(8, window.innerHeight - a.height - 8)), e.style.transform = `translate(${o}px, ${s}px)`;
	}, [n]), /* @__PURE__ */ f("div", {
		ref: r,
		className: t,
		style: {
			position: "fixed",
			top: 0,
			left: 0,
			willChange: "transform"
		},
		children: e
	});
}
function Wr({ children: e, className: n }) {
	let r = t.count(e) > 0;
	return /* @__PURE__ */ f(d, { children: r ? /* @__PURE__ */ f("div", {
		className: n,
		children: e
	}) : /* @__PURE__ */ f(d, {}) });
}
var Q = n({ isActive: !1 });
function Gr({ children: e, className: t, action: n }) {
	let { plugins: r, actions: i } = q(), a = D(), o = E(), s = i.find((e) => e.name === n);
	if (!s) return /* @__PURE__ */ f(d, {});
	let [c, , l] = Kr(a, o, s) || [
		!1,
		!1,
		!1
	];
	return c ? /* @__PURE__ */ f(Q.Provider, {
		value: {
			isActive: !!l,
			action: s
		},
		children: /* @__PURE__ */ f("a", {
			className: t,
			"data-state": l ? "active" : "inactive",
			onMouseDown: (e) => {
				e.preventDefault(), s.handler({
					editor: a,
					type: s.plugin.name,
					options: s.plugin.options,
					api: { consumeFileInputChangeEvent: (e, t) => {
						rn(e, r, t);
					} }
				});
			},
			children: e
		})
	}) : /* @__PURE__ */ f(d, {});
}
function Kr(e, t, n) {
	if (!t) return [
		!1,
		!1,
		!1
	];
	let r = Array.from(m.nodes(e, {
		at: m.unhangRange(e, t),
		match: (e) => !m.isEditor(e) && h.isElement(e)
	}));
	if (!r.length || !n?.visibility) return [
		!1,
		!1,
		!1
	];
	let i = r[0][0], a = r[r.length - 1][0];
	if (!U.isElement(i)) return [
		!1,
		!1,
		!1
	];
	let o = U.isElement(a) ? a : void 0;
	return n?.visibility(i, o) || [[
		!1,
		!1,
		!1
	]];
}
function qr({ children: e, className: n }) {
	let r = D(), { isActive: a, action: o } = i(Q), s = Array.isArray(o?.tool) ? o.tool[0] || null : o?.tool || null;
	return s && !t.count(e) ? /* @__PURE__ */ p("div", {
		className: n,
		children: [a && "✓", !a && s && /* @__PURE__ */ f(s, { editor: r })]
	}) : /* @__PURE__ */ f("div", {
		className: n,
		children: e
	});
}
function Jr() {
	if (typeof navigator > "u") return !1;
	let e = navigator, t = e.userAgentData?.platform || e.platform || e.userAgent || "";
	return /\bmac/i.test(t);
}
var Yr = Jr(), Xr = {
	up: "↑",
	down: "↓",
	right: "→",
	left: "←"
}, Zr = {
	mod: "⌘",
	shift: "⇧",
	ctrl: "⌃",
	control: "⌃",
	alt: "⌥",
	opt: "⌥",
	option: "⌥"
}, Qr = {
	mod: "Ctrl",
	ctrl: "Ctrl",
	control: "Ctrl",
	shift: "Shift",
	alt: "Alt",
	opt: "Alt",
	option: "Alt"
};
function $r(e, t = Yr) {
	return e ? e.split("+").map((e) => ei(e, t)).filter(Boolean).join(t ? "" : "+") : "";
}
function ei(e, t) {
	let n = e.toLowerCase();
	return ((t ? Zr : Qr)[n] ?? Xr[n]) || (e.length === 1 ? e.toUpperCase() : e);
}
function ti({ className: e, children: n }) {
	let { action: r } = i(Q);
	return /* @__PURE__ */ f("div", {
		className: e,
		children: t.count(n) ? n : $r(r?.hotkey || "")
	});
}
function ni({ children: e, className: n }) {
	let { action: r } = i(Q);
	return /* @__PURE__ */ f("div", {
		className: n,
		children: t.count(e) ? e : r?.title || ""
	});
}
var $ = {
	Menu: Rr,
	Trigger: Br,
	Content: Hr,
	Group: Wr,
	Item: Gr,
	Icon: qr,
	Hotkey: ti,
	Label: ni
};
function ri() {
	let e = i(G);
	if (e === void 0) throw Error("useContextMenu must be used within a ContextMenuContextProvider");
	return {
		menu: e.menu,
		spelling: e.spelling
	};
}
function ii({ children: e, className: t }) {
	return I(/* @__PURE__ */ f(ai, {
		className: t,
		children: e
	}), document.body);
}
function ai({ children: e, className: t }) {
	let { readOnly: n } = J(), o = i(G), s = l(null), { menu: c } = ri(), u = r(() => {
		let e = s.current;
		if (!e || !c?.position) return;
		let t = e.getBoundingClientRect(), { x: n, y: r } = c.position, i = n, a = r + 8, o = window.innerWidth - t.width - 8;
		i = Math.max(8, Math.min(i, o)), a + t.height > window.innerHeight - 8 && (a = r - t.height - 8), e.style.transform = `translate(${i}px, ${a}px)`;
	}, [c?.position]);
	return a(() => {
		if (!c?.position || n) return;
		let e = (e) => {
			s.current?.contains(e.target) || o?.dispatch({
				menu: void 0,
				spelling: void 0
			});
		};
		return window.addEventListener("pointerdown", e, { capture: !0 }), window.addEventListener("keydown", e, { capture: !0 }), () => {
			window.removeEventListener("pointerdown", e, { capture: !0 }), window.removeEventListener("keydown", e, { capture: !0 });
		};
	}, [
		n,
		c?.position,
		o
	]), a(() => {
		!n && c?.position && requestAnimationFrame(u);
	}, [
		n,
		c?.position,
		u
	]), !c?.position || n ? null : /* @__PURE__ */ f("div", {
		ref: s,
		className: t,
		style: {
			position: "fixed",
			top: 0,
			left: 0,
			willChange: "transform",
			pointerEvents: "auto",
			zIndex: 9702
		},
		children: e
	});
}
function oi({ children: e, className: n }) {
	return /* @__PURE__ */ f(d, { children: t.count(e) > 0 && /* @__PURE__ */ f("div", {
		className: n,
		children: e
	}) });
}
function si({ children: e, className: n, func: r = void 0 }) {
	let a = D(), o = i(G);
	return t.count(e) ? /* @__PURE__ */ f("a", {
		className: n,
		onMouseDown: (e) => {
			e.preventDefault(), r && r(a), o?.dispatch({
				menu: void 0,
				spelling: void 0
			});
		},
		children: e
	}) : /* @__PURE__ */ f(d, {});
}
var ci = {
	Root: ii,
	Group: oi,
	Item: si
}, li = {
	Root: Xt,
	Editable: _r,
	Gutter: yr.Content,
	DropMarker: br,
	UploadMarker: wr,
	Plugins: Ne,
	ContextMenu: ci
};
$.Menu, $.Trigger, $.Content, $.Group, $.Item, $.Icon, $.Label, $.Hotkey, Ir.Menu, Ir.Group, Ir.Item, yr.Content;
//#endregion
export { W as n, li as r, U as t };
